export const image_styles = [
  // Valentine's Day Photos
  {
    slug: 'valentines-day-photo',
    name: "Valentine's Day Photo",
    header: "Create Stunning Valentine's Day Photos",
    seo_description:
      "Generate beautiful Valentine's Day photos with our AI. Perfect for romantic portraits, couple photos, and celebrating love with professional quality images.",
    description:
      "Create stunning Valentine's Day photos with our AI. Generate professional quality romantic photos that capture the beauty and warmth of love.",
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'valentine photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c98dab4d-4586-4a8c-ae7f-572909acb493.png',
        prompt:
          "Valentine's Day romantic portrait, couple in elegant attire, surrounded by red roses and heart decorations, soft pink and red lighting, bokeh hearts in background, warm loving atmosphere",
      },
    ],
  },
  // Valentine's Day Card
  {
    slug: 'valentines-day-card',
    name: "Valentine's Day Card",
    header: "Create Your Own Valentine's Day Card",
    seo_description:
      "Generate beautiful Valentine's Day card designs with our AI. Perfect for sending romantic greetings to your loved ones.",
    description:
      "Design beautiful Valentine's Day cards with our AI. Create personalized romantic greetings with our collection of Valentine's card styles.",
    skipTitle: false,
    isPhotoPack: false,
    search_query: 'valentines day card',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8c58191f-ad92-47aa-b283-ad5da5dbddc5.png',
        prompt:
          "Valentine's Day card design with red and pink hearts, romantic roses, elegant calligraphy text area, soft watercolor background, love theme decorations",
      },
    ],
  },
  {
    slug: 'oil-painting',
    name: 'Oil Painting',
    header: 'Unleash Your Inner Artist with AI',
    seo_description:
      'Create mesmerizing oil paintings with our AI generator. Transform your ideas into captivating and detailed artwork.',
    description:
      'Unleash your inner artist with our AI. Create mesmerizing oil paintings that capture the essence of your ideas.',
    isArt: false,
    search_query: 'oil painting',
    isHidden: false,
    skipTitle: true,
    isPhotoPack: false,
    additional_title: '',
    images: [
      {
        url: 'https://media.easy-peasy.ai/74c32b29-92e2-4299-b1c5-2b377aec00ef/7f1bd532-c110-40b0-9c23-ad1b97a8f2e4.png',
        prompt:
          'Traditional oil painting with rich, textured brushstrokes, vibrant colors with depth and luminosity, classical composition with careful attention to light and shadow, museum-quality artistic style with visible paint layers and expressive techniques',
      },
    ],
  },
  {
    slug: 'realistic-photo',
    name: 'Realistic Photo',
    header: 'Capture the Details',
    seo_description:
      'Create high-definition, detailed photos with our AI generator. Perfect for adding a touch of realism to your projects.',
    description:
      'Capture the intricate details of your subjects with our AI. Create high-definition photos that bring your ideas to life in stunning clarity.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/realistic-photo-hero.mp4',
        prompt:
          'Photorealistic image with crisp details, natural lighting and shadows, accurate color reproduction, professional photography quality with sharp focus, lifelike textures and depth of field, high-resolution clarity capturing every intricate detail',
      },
    ],
  },
  {
    slug: 'cyberpunk',
    name: 'Cyberpunk',
    header: 'Step into the Future',
    isPhoto: true,
    search_query: 'cyberpunk photo',
    isPhotoPack: false,
    seo_description:
      'Generate edgy, futuristic cyberpunk images with our AI. Perfect for bringing your most outlandish sci-fi ideas to life.',
    description:
      'Step into the future with our AI. Generate edgy, vibrant cyberpunk images that transport you to a world of high-tech and low-life.',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/926cd4ee-a299-456d-bb08-94ea60fdb185.png',
        prompt:
          'Futuristic cyberpunk aesthetic with neon lights in vibrant pink, blue and purple, dark urban atmosphere with rain-slicked surfaces, high-tech elements mixed with gritty dystopian streets, holographic displays and digital billboards, moody sci-fi setting with dramatic contrasts between bright neon and deep shadows',
      },
    ],
  },
  {
    slug: 'watercolor',
    name: 'Watercolor',
    header: 'Paint with Pixels',
    seo_description:
      'Generate beautiful watercolor paintings with our AI. Perfect for creating soft, dreamy images and landscapes.',
    description:
      'Unleash your creativity with our AI. Generate beautiful watercolor paintings that capture the soft, dreamy essence of your ideas.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/75f38b44-1c35-4b52-bc64-ecf6ce247041/47ee6d7f-bf13-434a-8b10-3a824598ce48.png',
        prompt:
          'Delicate watercolor painting with soft, translucent washes of color, gentle bleeding and blending effects, dreamy ethereal quality with visible paper texture, flowing brushstrokes and organic color transitions, light and airy atmosphere with subtle gradients',
      },
    ],
  },
  {
    slug: 'pencil-drawing',
    name: 'Pencil drawing',
    header: 'Sketch Your Ideas',
    seo_description:
      'Create detailed pencil drawings with our AI. Perfect for sketching your ideas and bringing them to life.',
    description:
      'Sketch your ideas and bring them to life with our AI. Create detailed pencil drawings that capture the essence of your concepts.',
    isArt: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/35d5a24e-5f10-4d22-86fd-ce689d54a050/56a698a2-b0b7-4cdf-838e-69fe55bb2fee.png',
        prompt:
          'Detailed pencil drawing with fine graphite lines and careful shading, realistic sketching technique with cross-hatching and tonal variations, artistic hand-drawn quality with visible pencil marks, monochromatic grayscale with depth and dimension, precise linework capturing form and texture',
      },
    ],
  },
  {
    slug: 'cartoon',
    name: 'Cartoon',
    header: 'Animate Your Ideas',
    seo_description:
      'Create fun and vibrant cartoons with our AI. Perfect for animation, storyboarding, and character design.',
    description:
      'Animate your ideas with our AI. Create fun and vibrant cartoons that bring your stories to life.',
    images: [
      {
        url: 'https://media.easy-peasy.ai/ca6a1be9-60d7-4dc6-820c-e5580ce6844b/586bfc52-c6c0-4ea0-a452-339fcd380e05.png',
        prompt:
          'Vibrant cartoon illustration with bold outlines and bright colors, playful animated style with simplified forms and exaggerated features, clean vector-like appearance with smooth shading, cheerful and energetic visual design perfect for character animation and storyboarding',
      },
    ],
  },
  {
    slug: 'disney',
    name: 'Disney',
    header: 'Create Disney-style images online with AI',
    seo_description:
      'Generate Disney-style images with our AI. Perfect for creating unique, eye-catching designs.',
    description:
      'Create Disney-style images with our AI. Generate stunning images that bring your ideas to life.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 864x496, full 15s, muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/disney-native.mp4',
        prompt:
          'Classic Disney animation style with warm, appealing character design, soft rounded features and expressive eyes, magical storybook quality with rich colors and enchanting atmosphere, family-friendly aesthetic with whimsical details and timeless charm',
      },
    ],
  },
  {
    slug: 'pixar',
    name: 'Pixar',
    header: 'Create Pixar images online with AI',
    seo_description:
      'Generate Pixar-style images with our AI. Perfect for creating unique, eye-catching designs.',
    description:
      'Create Pixar-style images with our AI. Generate stunning images that bring your ideas to life.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/pixar-hero.mp4',
        prompt:
          'Pixar-style 3D animation with highly detailed textures and realistic lighting, charming character design with expressive faces and emotional depth, vibrant saturated colors with professional ray-traced rendering, polished cinematic quality with subtle imperfections for warmth and personality',
      },
    ],
  },
  {
    slug: 'disney-pixar-poster',
    name: 'Disney Poster',
    header: 'Create Your Own Disney/Pixar Poster',
    seo_description:
      'Generate stunning Disney/Pixar-style posters with our AI. Perfect for bringing your ideas to life.',
    description:
      'Create your own Disney-style posters with our AI. Generate stunning images that bring your ideas to life.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/28ee7342-64de-4f73-97fc-2a6203378ac1.png',
        prompt:
          'Disney Pixar movie poster design with theatrical composition, vibrant character artwork with emotional storytelling, cinematic title treatment and professional layout, magical atmosphere with dramatic lighting and engaging visual narrative, polished promotional art style',
      },

      {
        url: 'https://media.easy-peasy.ai/1700a491-b27b-46eb-92a5-abedb237ccd3/2fe69f6c-22a9-4ad4-a33f-16b36ed45d26.png',
        prompt:
          'Disney Pixar movie poster design with theatrical composition, vibrant character artwork with emotional storytelling, cinematic title treatment and professional layout, magical atmosphere with dramatic lighting and engaging visual narrative, polished promotional art style',
      },
      {
        url: 'https://media.easy-peasy.ai/996e13eb-7fbe-41a2-8178-f72efdc37d7b/119e50fc-8273-443e-b5be-f892079053e5.png',
        prompt:
          'Disney Pixar movie poster design with theatrical composition, vibrant character artwork with emotional storytelling, cinematic title treatment and professional layout, magical atmosphere with dramatic lighting and engaging visual narrative, polished promotional art style',
      },
    ],
  },
  {
    slug: 'movie-poster',
    name: 'Movie Poster',
    header: 'Create Your Own Movie Poster',
    seo_description:
      'Generate stunning movie posters with our AI. Perfect for bringing your cinematic ideas to life.',
    description:
      'Create your own movie posters with our AI. Generate stunning images that bring your cinematic ideas to life.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/4866a5d8-32ba-4af9-ab35-210548b4876f.png',
        prompt:
          'Cinematic movie poster design with dramatic composition and bold typography, theatrical lighting and compelling visual hierarchy, professional graphic design with layered imagery and striking color palette, blockbuster film aesthetic with marketing-ready polish',
      },
    ],
  },
  {
    slug: 'anime',
    name: 'Anime',
    header: 'Create Your Own Anime',
    seo_description:
      'Generate beautiful anime style art with our AI. Perfect for manga, light novels, and animation.',
    description:
      'Create your own anime with our AI. Generate beautiful anime style art that captures the essence of your stories.',
    isArt: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1) — the full take. Seedance pushed the
        // camera much harder than the prompt asked, so the loop cuts from a
        // close-up back to the wide opening; `-v2` because the first upload of
        // this key is CDN-cached immutable.
        url: 'https://media.easy-peasy.ai/landing/image-styles/anime-v2.mp4',
        prompt:
          'Japanese anime art style with large expressive eyes and distinctive facial features, clean cel-shaded coloring with vibrant hues, detailed hair with flowing strands and highlights, dynamic poses and emotional expressions, manga-inspired aesthetic with sharp linework',
      },
    ],
  },
  {
    slug: 'mosaic',
    name: 'Mosaic',
    header: 'Piece Together Your Ideas',
    seo_description:
      'Create intricate mosaic images with our AI. Perfect for creating unique, eye-catching designs.',
    description:
      'Piece together your ideas with our AI. Create intricate mosaic images that are as unique and eye-catching as your concepts.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/mosaic-hero.mp4',
        prompt:
          'Intricate mosaic artwork composed of small colorful tiles and fragments, tessellated pattern with rich texture and dimensional quality, ancient artistic technique with modern color palette, detailed geometric assembly creating cohesive imagery from individual pieces',
      },
    ],
  },
  {
    slug: '3d-model',
    name: '3D Model',
    header: 'Bring Your Ideas to Life in 3D',
    seo_description:
      'Generate realistic 3D renders with our AI. Perfect for product design, architecture, and more.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/35549d1d-e82e-4f6e-ab18-811ee0f8c29b/a41efdc9-a705-4e49-a6e0-7cd1f094f001.png',
        prompt:
          'Professional 3D rendered model with realistic materials and textures, accurate geometric forms with clean topology, studio lighting setup with ambient occlusion and global illumination, high-quality CGI visualization with depth and dimensionality, production-ready 3D asset quality',
      },
    ],
  },
  {
    slug: 'portrait',
    name: 'Portrait',
    header: 'Capture the Perfect Portrait',
    seo_description:
      'Create stunning portraits with our AI. Perfect for capturing the essence of your subject.',
    skipTitle: false,
    isPhoto: true,
    search_query: 'professional portrait',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/188a927d-4d4f-4ac9-bbee-b39c75589a81.png',
        prompt:
          'Professional portrait photography with flattering lighting and careful composition, sharp focus on facial features with natural skin tones, shallow depth of field emphasizing the subject, studio or environmental portrait quality with emotional connection and personality',
      },
    ],
  },
  {
    slug: 'icon',
    name: 'Icon',
    header: 'Iconic Designs at Your Fingertips',
    seo_description:
      'Create striking icons with our AI. Perfect for web design, apps, and more.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/e36c9c9c-25b1-4e53-b334-a3095bd2dcc8/e8ec701e-a2e9-4d99-a496-43cb890fd7d6.png',
        prompt:
          'Clean, minimalist icon design with simple geometric shapes and bold colors, flat or 3D style with clear silhouette, scalable vector quality suitable for digital interfaces, recognizable symbol with professional polish and modern aesthetic',
      },
      {
        url: 'https://media.easy-peasy.ai/e36c9c9c-25b1-4e53-b334-a3095bd2dcc8/0022a98c-6edf-41bf-a03d-5520cac3eee5.png',
        prompt:
          'Clean, minimalist icon design with simple geometric shapes and bold colors, flat or 3D style with clear silhouette, scalable vector quality suitable for digital interfaces, recognizable symbol with professional polish and modern aesthetic',
      },

      {
        url: 'https://media.easy-peasy.ai/62805a70-6b6e-40dc-bf6f-f9b6a47d18d4/396eb261-6392-4710-8efd-4a601b02bc58.png',
        prompt:
          'Clean, minimalist icon design with simple geometric shapes and bold colors, flat or 3D style with clear silhouette, scalable vector quality suitable for digital interfaces, recognizable symbol with professional polish and modern aesthetic',
      },
    ],
  },
  {
    slug: 'sticker',
    name: 'Sticker',
    header: 'Stick to Your Ideas',
    seo_description:
      'Create fun and unique stickers with our AI. Perfect for personalizing your belongings or for your business.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/fb06a0f6-f706-4793-ae55-30d3083aac49.png',
        prompt:
          'Fun sticker design with bold outlines and vibrant colors, die-cut style with white border, playful illustration perfect for decorating, glossy vinyl aesthetic with punchy graphics, eye-catching design suitable for printing and merchandise',
      },
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/60f3c453-ba3b-418c-9bdc-582ba9cdfb33.png',
        prompt:
          'Fun sticker design with bold outlines and vibrant colors, die-cut style with white border, playful illustration perfect for decorating, glossy vinyl aesthetic with punchy graphics, eye-catching design suitable for printing and merchandise',
      },
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/373947ac-77d9-4e31-a833-486d5914ff3d.png',
        prompt:
          'Fun sticker design with bold outlines and vibrant colors, die-cut style with white border, playful illustration perfect for decorating, glossy vinyl aesthetic with punchy graphics, eye-catching design suitable for printing and merchandise',
      },
    ],
  },
  {
    slug: 'landscape',
    name: 'Landscape',
    header: 'Create Stunning Landscapes',
    seo_description:
      'Generate breathtaking landscape images with our AI. Perfect for digital art, game backgrounds, and more.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/30abd6c9-2ef9-4b70-8f28-0b5404d59bf0/43ed2a4e-1762-4685-a88a-bdc1d9190bb2.png',
        prompt:
          'Breathtaking landscape scenery with expansive natural vista, dramatic lighting and atmospheric perspective, rich environmental details with foreground, midground and background elements, scenic beauty capturing the majesty of nature with compelling composition',
      },
    ],
  },
  {
    slug: 'pokemon',
    name: 'Pokemon',
    header: 'Generate Your Favorite Pokemon',
    seo_description:
      'Create images of your favorite Pokemon with our AI. Perfect for Pokemon fans and digital artists.',
    isArt: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/pokemon-hero.mp4',
        prompt:
          'Pokemon-style creature design with vibrant colors and distinctive features, anime-inspired aesthetic with cute or powerful appearance, clean character design with recognizable silhouette, fantasy creature with elemental or thematic visual traits',
      },
    ],
  },
  {
    slug: 'logo',
    name: 'Logo',
    header: 'Brand Yourself with AI',
    seo_description:
      'Create unique and memorable logos with our AI. Perfect for businesses, personal branding, and more.',
    skipTitle: true,
    additional_title: ' From Text',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a slow specular light sweep across the gold foil,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/logo-hero.mp4',
        prompt:
          'Professional logo design with clean typography and memorable iconography, versatile brand mark suitable for various applications, balanced composition with strong visual identity, modern corporate aesthetic with timeless appeal and scalable vector quality',
      },
    ],
  },
  {
    slug: 'business-card',
    name: 'Business Card',
    header: 'Design Your Professional Business Card',
    seo_description:
      'Create professional business card designs with our AI. Perfect for entrepreneurs, professionals, and businesses.',
    description:
      'Design elegant and impactful business cards with our AI. Make a lasting first impression with our collection of business card styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/77e28236-7ee7-4f05-afef-64f972d74c7f.webp',
        prompt:
          'Professional business card design with elegant layout and clear hierarchy, sophisticated typography and balanced visual elements, premium aesthetic with attention to detail, clean modern design suitable for print with proper spacing and alignment',
      },
    ],
  },
  {
    slug: 'band-logo',
    name: 'Band Logo',
    header: 'Design Your Band Logo',
    seo_description:
      'Create unique and eye-catching band logos with our AI. Perfect for musicians, bands, and music industry professionals.',
    description:
      'Design striking band logos that capture your musical identity. From metal to indie, create logos that resonate with your genre and style.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/557c5d29-d527-41b5-b191-f64715ee8677/d526a18b-3679-43be-922d-008f64af470c.png',
        prompt:
          'Eye-catching band logo with genre-specific styling and bold typography, distinctive lettering design that captures musical identity, edgy or artistic aesthetic suitable for merchandise and album covers, memorable mark with strong visual impact',
      },
    ],
  },
  {
    slug: 'furry',
    name: 'Furry',
    header: 'Create Your Own Fursona',
    isArt: true,
    seo_description:
      'Generate your own furry character with our AI. Allows you to make any style of furry creations from simple text descriptions.',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/furry-hero.mp4',
        prompt:
          'Anthropomorphic character art with animal features and human-like qualities, detailed fur textures and expressive personality, vibrant furry fandom aesthetic with distinctive character design, artistic illustration style with creative freedom and emotional expression',
      },
    ],
  },
  {
    slug: 't-shirt-design',
    name: 'T-Shirt Design',
    header: 'Create Your Own T-Shirt Design',
    seo_description:
      'Generate your own t-shirt designs with our AI. Perfect for creating unique, eye-catching designs.',
    description:
      'Create your own t-shirt designs with our AI. Generate stunning images that bring your ideas to life.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/t-shirt-design-hero.mp4',
        prompt:
          'Creative t-shirt graphic design with bold visual impact, print-ready artwork with balanced composition, trendy streetwear aesthetic or artistic illustration style, eye-catching design suitable for apparel printing with strong color contrast',
      },
    ],
  },
  {
    slug: 'jersey',
    name: 'Jersey',
    header: 'Create Your Own Jersey Design',
    seo_description:
      'Generate your own custom jersey designs with our AI. Perfect for sports teams, fan merchandise, or personal use.',
    description:
      'Create your own jersey designs with our AI. Generate stunning and unique sports jersey concepts that bring your team spirit to life.',
    skipTitle: true,
    // Both hero tiles are animated: stills from GPT Image 2 Medium, animated
    // with Seedance 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to
    // 720x720. One shows the jersey worn, one on the hanger.
    images: [
      {
        url: 'https://media.easy-peasy.ai/landing/image-styles/jersey-worn.mp4',
        prompt:
          'Professional sports jersey design with athletic aesthetics and team colors, dynamic patterns or clean modern styling, official sports apparel quality with sponsor placement zones, performance-ready design suitable for printing on athletic fabric',
      },
      {
        url: 'https://media.easy-peasy.ai/landing/image-styles/jersey-hanging.mp4',
        prompt:
          'Professional sports jersey design with athletic aesthetics and team colors, dynamic patterns or clean modern styling, official sports apparel quality with sponsor placement zones, performance-ready design suitable for printing on athletic fabric',
      },
    ],
  },
  {
    slug: 'hoodie',
    name: 'Hoodie',
    header: 'Create Your Own Hoodie Design',
    seo_description:
      'Generate your own hoodie designs with our AI. Perfect for creating unique, comfortable streetwear.',
    description:
      'Create your own hoodie designs with our AI. Generate eye-catching designs that bring your streetwear ideas to life.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as the model turning toward camera as the camera drifts in,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/hoodie-hero.mp4',
        prompt:
          'Trendy hoodie design with contemporary streetwear styling, bold graphics or artistic elements on front or back, urban fashion aesthetic with modern typography, comfortable casual design suitable for apparel mockup and production',
      },
      {
        url: 'https://media.easy-peasy.ai/d9aeaa50-dea9-4862-bdb9-df751cb49337/9a1894ca-0661-415e-b653-136779fc3a32.png',
        prompt:
          'Trendy hoodie design with contemporary streetwear styling, bold graphics or artistic elements on front or back, urban fashion aesthetic with modern typography, comfortable casual design suitable for apparel mockup and production',
      },
    ],
  },
  {
    slug: 'tattoo',
    name: 'Tattoo',
    header: 'Create Your Own Tattoo',
    seo_description:
      'Generate your own tattoo designs with our AI. Get inspired by our collection of tattoo designs.',
    description:
      'Create your own tattoo designs with our AI. Unleash your creativity with our collection of tattoo designs.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/c0389b47-d13e-4d79-85f3-6c54167d8165/e07c4e56-310a-4aa1-9b0d-0c98d11b144c.webp',
        prompt:
          'Artistic tattoo design with bold linework and creative imagery, traditional or modern ink style with strong visual flow, detailed illustration suitable for body art placement, symbolic or decorative artwork with timeless appeal and cultural significance',
      },
    ],
  },
  {
    slug: 'birth-flower-tattoo',
    name: 'Birth Flower Tattoo',
    header: 'Create Your Birth Flower Tattoo',
    seo_description:
      'Generate beautiful birth flower tattoo designs with our AI. Perfect for creating meaningful, personalized tattoo art representing your birth month.',
    description:
      'Create stunning birth flower tattoo designs with our AI. Generate delicate floral artwork that captures the symbolism of your birth month flower.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2cdf39fc-2763-4b68-8b2c-0625eb76fc58.png',
        prompt:
          'Elegant birth flower tattoo design with botanical accuracy and artistic styling, delicate floral linework representing specific month, meaningful personal symbolism with refined aesthetic, black ink or colored tattoo style perfect for commemorative body art',
      },
    ],
  },
  {
    slug: 'fantasy',
    name: 'Fantasy',
    header: 'Create Your Own Fantasy Image',
    seo_description:
      'Generate your own fantasy images with our AI. Perfect for digital art, game backgrounds, and more.',
    description:
      'Create your own fantasy images with our AI. Unleash your creativity with our collection of fantasy images.',
    isArt: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/fantasy-hero.mp4',
        prompt:
          'Epic fantasy artwork with magical elements and mythical creatures, rich imaginative world-building with dramatic lighting and mystical atmosphere, enchanted landscapes or heroic characters in fantastical settings, vibrant otherworldly colors with ethereal quality and dreamlike wonder',
      },
      {
        url: 'https://media.easy-peasy.ai/1d6463b1-cfb8-4099-89a2-10f861ef0595/e6b53fa7-292d-477a-b3b9-dc4cdc5dac1c.png',
        prompt:
          'Epic fantasy artwork with magical elements and mythical creatures, rich imaginative world-building with dramatic lighting and mystical atmosphere, enchanted landscapes or heroic characters in fantastical settings, vibrant otherworldly colors with ethereal quality and dreamlike wonder',
      },
      {
        url: 'https://media.easy-peasy.ai/a11b626f-ce28-49d2-be5f-b1a52db7657f/5759ad42-5803-4d7f-b854-d56da59b0f45.png',
        prompt:
          'Epic fantasy artwork with magical elements and mythical creatures, rich imaginative world-building with dramatic lighting and mystical atmosphere, enchanted landscapes or heroic characters in fantastical settings, vibrant otherworldly colors with ethereal quality and dreamlike wonder',
      },
    ],
  },
  {
    slug: 'fantasy-map',
    name: 'Fantasy Map',
    header: 'Generate Your Own Fantasy Map',
    seo_description:
      'Create your own fantasy map with our AI. Perfect for world-building, game design, and more.',
    description:
      'Generate your own fantasy map with our AI. Bring your world to life with our collection of map styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/9fd8d04d-d843-403d-ad52-29ea9ec631ba/5e21f84d-d1eb-45e4-8ad7-080e2a7e1aff.png',
        prompt:
          'Detailed fantasy map with medieval cartography style, hand-drawn aesthetic with mountains, forests, and kingdoms, aged parchment texture with decorative borders and compass rose, world-building visualization perfect for RPG campaigns and fictional worlds',
      },
    ],
  },
  {
    slug: 'dnd',
    name: 'DND',
    header:
      'Create Your Own Dungeons & Dragons Image: Characters, Backgrounds, and More',
    seo_description:
      'Generate your own Dungeons & Dragons Art with our AI. Just enter prompt to create DnD AI art or character by using our AI tool.',
    description:
      'Create your own Dungeons & Dragons Art with our AI. Unleash your creativity with our collection of DnD AI art.',
    isArt: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/00255baa-a07c-4a37-9ede-f778c4dc6506/d9d6ff2f-a185-4681-a69f-484fba08d0a9.png',
        prompt:
          'Dungeons & Dragons character art with detailed fantasy RPG styling, heroic adventurer design with medieval armor or robes, dramatic lighting and rich colors reminiscent of classic fantasy illustration, epic character portrait perfect for tabletop gaming and storytelling',
      },
      {
        url: 'https://media.easy-peasy.ai/d0f3e728-1c14-47fa-bc09-9a70b62d5d40/c870b637-940e-4aaa-b798-c13de11ea2a3.png',
        prompt:
          'Dungeons & Dragons character art with detailed fantasy RPG styling, heroic adventurer design with medieval armor or robes, dramatic lighting and rich colors reminiscent of classic fantasy illustration, epic character portrait perfect for tabletop gaming and storytelling',
      },
      {
        url: 'https://media.easy-peasy.ai/00255baa-a07c-4a37-9ede-f778c4dc6506/aa073f6a-75c1-458b-8ab6-7cf3b1492dac.png',
        prompt:
          'Dungeons & Dragons character art with detailed fantasy RPG styling, heroic adventurer design with medieval armor or robes, dramatic lighting and rich colors reminiscent of classic fantasy illustration, epic character portrait perfect for tabletop gaming and storytelling',
      },

      {
        url: 'https://media.easy-peasy.ai/00255baa-a07c-4a37-9ede-f778c4dc6506/cf1754f3-8fe1-42bb-bd2f-25d2dd29be4e.png',
        prompt:
          'Dungeons & Dragons character art with detailed fantasy RPG styling, heroic adventurer design with medieval armor or robes, dramatic lighting and rich colors reminiscent of classic fantasy illustration, epic character portrait perfect for tabletop gaming and storytelling',
      },
    ],
  },
  {
    slug: 'album-cover',
    name: 'Album Cover',
    header: 'Create Your Own Album Cover',
    seo_description:
      'Generate your own album cover with our AI. Perfect for musicians and music lovers.',
    description:
      'Create your own album cover with our AI. Unleash your creativity with our collection of album covers.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/af01ccdb-c3b3-4194-b9af-0d1e4e999a7f/ada3e2f2-a06f-434b-813e-eb26cb35ef10.png',
        prompt:
          'Professional album cover design with artistic visual concept matching musical genre, bold graphic design with typography and imagery, creative composition capturing the essence and mood of the music, print-ready artwork with striking visual impact',
      },
    ],
  },
  {
    slug: 'pixel-art',
    name: 'Pixel Art',
    header: 'Create Your Own Pixel Art',
    seo_description:
      'Generate your own pixel art with our AI. Perfect for game developers and pixel art enthusiasts.',
    description:
      'Create your own pixel art with our AI. Bring your pixelated ideas to life with our collection of pixel art styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/5a80f095-851b-4347-9ca2-21a9387bf587/01ea011f-28e5-44ac-953e-e5040c94a223.png',
        prompt:
          'Retro pixel art with blocky 8-bit or 16-bit aesthetic, nostalgic video game graphics style with limited color palette, crisp pixelated design with careful sprite work, charming retro gaming visual perfect for indie games and digital art',
      },
      {
        url: 'https://media.easy-peasy.ai/9bb794da-f394-40a8-8f43-b5b30bd43786/32f1d18a-a2fc-47c9-afba-23c4ebef63ad.png',
        prompt:
          'Retro pixel art with blocky 8-bit or 16-bit aesthetic, nostalgic video game graphics style with limited color palette, crisp pixelated design with careful sprite work, charming retro gaming visual perfect for indie games and digital art',
      },
      {
        url: 'https://media.easy-peasy.ai/c54d4981-bd94-4020-bdd1-043e9f4337d6/4d1c85e6-f9cf-43a3-8cf3-65c42bd2032d.png',
        prompt:
          'Retro pixel art with blocky 8-bit or 16-bit aesthetic, nostalgic video game graphics style with limited color palette, crisp pixelated design with careful sprite work, charming retro gaming visual perfect for indie games and digital art',
      },
      {
        url: 'https://media.easy-peasy.ai/fd90eeea-1dc8-41bd-925f-c3ee4b4930d5/30e13262-6794-4b14-af6a-e76bcbc13434.png',
        prompt:
          'Retro pixel art with blocky 8-bit or 16-bit aesthetic, nostalgic video game graphics style with limited color palette, crisp pixelated design with careful sprite work, charming retro gaming visual perfect for indie games and digital art',
      },
    ],
  },
  {
    slug: 'coloring-page',
    name: 'Coloring Page',
    header: 'Create Your Own Coloring Pages',
    seo_description:
      'Generate custom coloring pages with our AI. Perfect for creating unique line art designs ready for coloring.',
    description:
      'Design your own coloring pages with our AI. Create detailed line art illustrations perfect for coloring books, educational materials, or artistic projects.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c24a7c59-bbb9-44ae-b504-da3685bd6986.svg',
        prompt:
          'Black and white line art illustration perfect for coloring, clean outlines with intricate details and patterns, uncolored drawing with clear boundaries for easy coloring, engaging design suitable for coloring books and creative activities',
      },
    ],
  },
  {
    slug: 'coloring-book',
    name: 'Coloring Book',
    header: 'Create Your Own Coloring Book',
    seo_description:
      'Generate your own coloring book pages with our AI. Perfect for artists and coloring enthusiasts.',
    description:
      'Create your own coloring book with our AI. Bring your ideas to life with our collection of coloring book styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/coloring-book-hero.mp4',
        prompt:
          'Black and white coloring book page with clean line art, detailed illustrations designed for coloring activities, simple to complex patterns with clear outlines, educational and entertaining design suitable for all ages',
      },
    ],
  },
  {
    slug: 'texture',
    name: 'Texture',
    header: 'Create Your Own Texture',
    seo_description:
      'Generate your own texture with our AI. Perfect for artists and texture enthusiasts.',
    description:
      'Create your own texture with our AI. Bring your ideas to life with our collection of texture styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/989d14ca-c1ac-4150-a275-aeff1d2a6583/5a996c1f-f494-4f5b-a5a8-969c8de111ab.png',
        prompt:
          'Seamless tileable texture with realistic surface details, high-resolution material pattern with consistent repeating design, detailed surface qualities like wood grain, fabric weave, stone or metal, perfect for 3D rendering and digital art backgrounds',
      },
    ],
  },
  {
    slug: 'animal',
    name: 'Animal',
    header: 'Create Your Own Animal Art',
    seo_description:
      'Generate your own animal art with our AI. Perfect for artists and animal enthusiasts.',
    description:
      'Create your own animal art with our AI. Bring your ideas to life with our collection of animal art styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted, 960px wide.
        url: 'https://media.easy-peasy.ai/landing/image-styles/animal-hero.mp4',
        prompt:
          'Beautiful animal portrait or illustration with lifelike details, realistic or artistic interpretation of wildlife, expressive features capturing the essence and personality of the creature, stunning natural beauty with careful attention to fur, feathers or scales',
      },
    ],
  },
  {
    slug: 'car',
    name: 'Car',
    header: 'Create Your Own Car Design',
    seo_description:
      'Generate your own car design with our AI. Perfect for car enthusiasts and designers.',
    description:
      'Create your own car design with our AI. Bring your ideas to life with our collection of car styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/50bcef25-312e-4c97-9643-11ca14c5726d/fa67b834-3a3f-4f18-bfbc-49b015dafcbd.png',
        prompt:
          'Sleek automotive design with dynamic styling and modern aesthetics, professional car visualization with polished details and reflective surfaces, concept car or production vehicle rendering with dramatic lighting, showroom-quality presentation perfect for enthusiasts',
      },
    ],
  },
  {
    slug: 'lego',
    name: 'Lego',
    header: 'Create Your Own Lego Design',
    seo_description:
      'Generate your own Lego design with our AI. Perfect for Lego enthusiasts and designers.',
    description:
      'Create your own Lego design with our AI. Bring your ideas to life with our collection of Lego styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/lego-hero.mp4',
        prompt:
          'LEGO brick-built design with colorful interlocking blocks, playful toy construction aesthetic with recognizable LEGO minifigure style, detailed building block assembly with vibrant primary colors, nostalgic childhood toy visualization perfect for creative building concepts',
      },
    ],
  },
  {
    slug: 'minecraft',
    name: 'Minecraft',
    header: 'Create Your Own Minecraft Design',
    seo_description:
      'Generate your own Minecraft design with our AI. Perfect for Minecraft enthusiasts and designers.',
    description:
      'Create your own Minecraft design with our AI. Bring your ideas to life with our collection of Minecraft styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/minecraft-hero.mp4',
        prompt:
          'Minecraft blocky voxel art style with cube-based construction, pixelated low-poly game aesthetic with signature block textures, procedurally generated world visualization with recognizable Minecraft elements, nostalgic sandbox game design perfect for gaming enthusiasts',
      },
      {
        url: 'https://media.easy-peasy.ai/ac86050f-549e-45f7-ad39-c3fe8ea3ccce/88e104ef-81ba-4f9a-acf8-6da45ddb5ddd.png',
        prompt:
          'Minecraft blocky voxel art style with cube-based construction, pixelated low-poly game aesthetic with signature block textures, procedurally generated world visualization with recognizable Minecraft elements, nostalgic sandbox game design perfect for gaming enthusiasts',
      },
    ],
  },
  {
    slug: 'hello-kitty',
    name: 'Hello Kitty',
    header: 'Create Your Own Hello Kitty Design',
    seo_description:
      'Generate your own Hello Kitty design with our AI. Perfect for Hello Kitty enthusiasts and designers.',
    description:
      'Create your own Hello Kitty design with our AI. Bring your ideas to life with our collection of Hello Kitty styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/b55245d7-af15-4105-95ff-c50ada488102/8587c626-d180-41f6-9e59-eb4b6e2b4398.png',
        prompt:
          'Cute Hello Kitty-style kawaii character design with simple rounded features, adorable Japanese Sanrio aesthetic with pastel colors and cheerful expression, charming minimalist character art perfect for merchandise and fan creations',
      },
    ],
  },
  {
    slug: 'mascot',
    name: 'Mascot',
    header: 'Create Your Own Mascot Design',
    seo_description:
      'Generate your own mascot design with our AI. Perfect for sports teams, businesses, and more.',
    description:
      'Create your own mascot design with our AI. Bring your ideas to life with our collection of mascot styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/assets/468f1791-a4c5-4d8d-8f15-95b71166ac2c.mp4',
        prompt:
          'An adorable friendly fox mascot character standing in a confident hero pose with arms crossed, wearing a small blue cape and sneakers, bright orange fur with a white chest, big expressive eyes and a cheerful smile, clean vector illustration style, solid white background, full body character design, perfect for logo and branding, vibrant flat colors, high detail cartoon style, professional mascot design sheet',
      },
    ],
  },
  {
    slug: 'superhero',
    name: 'Superhero',
    header: 'Create Your Own Superhero Design',
    seo_description:
      'Generate your own superhero design with our AI. Perfect for comic book artists, fans and creators.',
    description:
      'Create your own superhero design with our AI. Bring your ideas to life with our collection of superhero styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2467ed04-d851-412b-9336-7fd726740534.png',
        prompt:
          'Dynamic superhero character design with heroic costume and powerful stance, comic book art style with bold colors and dramatic composition, muscular physique with distinctive costume elements and cape, epic action hero perfect for comic books and graphic novels',
      },
    ],
  },
  {
    slug: 'monster',
    name: 'Monster',
    header: 'Create Your Own Monster Design',
    seo_description:
      'Generate your own monster design with our AI. Perfect for game developers, fantasy enthusiasts and designers.',
    description:
      'Create your own monster design with our AI. Bring your ideas to life with our collection of monster styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/monster-hero.mp4',
        prompt:
          'Imaginative monster creature design with unique features and menacing or whimsical appearance, fantasy beast with creative anatomy and distinctive characteristics, detailed creature concept art perfect for games, horror or fantasy storytelling',
      },
    ],
  },
  {
    slug: 'sewing-pattern',
    name: 'Sewing Pattern',
    header: 'Create Your Own Sewing Pattern',
    seo_description:
      'Generate your own sewing pattern with our AI. Perfect for fashion designers and hobbyists.',
    description:
      'Create your own sewing pattern with our AI. Bring your ideas to life with our collection of sewing pattern styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c4b7e8d2-1a15-4be5-824a-b5191077deea.png',
        prompt:
          'Technical sewing pattern with precise measurements and construction lines, dressmaker template with pattern pieces and assembly instructions, professional fashion pattern layout suitable for garment manufacturing and DIY sewing projects',
      },
    ],
  },
  {
    slug: 'crochet-pattern',
    name: 'Crochet Pattern',
    header: 'Create Your Own Crochet Pattern',
    seo_description:
      'Generate your own crochet pattern with our AI. Perfect for crafters, designers, and hobbyists.',
    description:
      'Create your own crochet pattern with our AI. Bring your ideas to life with our collection of crochet pattern styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2024-09-13T06:03:37.723Z.png',
        prompt:
          'Detailed crochet pattern diagram with step-by-step stitch instructions, handmade craft design showing yarn texture and hook techniques, amigurumi or decorative crochet project visualization, DIY fiber arts pattern perfect for knitting and crochet enthusiasts',
      },
    ],
  },
  {
    slug: 'clothing-design',
    name: 'Clothing Design',
    header: 'Create Your Own Clothing Design',
    seo_description:
      'Generate your own clothing design with our AI. Perfect for fashion designers, stylists, and creative individuals.',
    description:
      'Create your own clothing design with our AI. Bring your fashion ideas to life with our collection of clothing design styles.',
    skipTitle: true,
    // Animated hero: a single lookbook still showing a male and a female model
    // in one coordinated collection (GPT Image 2 Medium), animated with
    // Seedance 2.0 Mini Image (720p, 4s, 1:1). Replaces the four separate
    // stills so the page leads with one large moving showcase.
    images: [
      {
        url: 'https://media.easy-peasy.ai/landing/image-styles/clothing-design-hero.mp4',
        prompt:
          'Fashion design illustration with detailed garment concepts, runway-ready clothing sketches with fabric details and styling, haute couture or ready-to-wear fashion visualization, professional fashion illustration suitable for lookbooks and collections',
      },
    ],
  },
  {
    slug: 'architecture',
    name: 'Architecture',
    header: 'Create Your Own Architectural Design Concepts',
    seo_description:
      'Generate your own architectural design concepts with our AI. Perfect for architects, designers, and urban planners.',
    description:
      'Create your own architectural design with our AI. Bring your ideas to life with our collection of architectural styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/19138ceb-15df-44f3-9774-2b25e63d0cfd.png',
        prompt:
          'Architectural visualization with modern or classical building design, detailed structural rendering with materials and spatial composition, professional architectural concept showcasing form and function, photorealistic or artistic architectural illustration',
      },
      {
        url: 'https://media.easy-peasy.ai/bacd9d51-a3d5-45bd-9132-6a315b12e43a/2aa0ae71-d893-45bd-b8a4-f9bbe2b21335.png',
        prompt:
          'Architectural visualization with modern or classical building design, detailed structural rendering with materials and spatial composition, professional architectural concept showcasing form and function, photorealistic or artistic architectural illustration',
      },
      {
        url: 'https://media.easy-peasy.ai/afc0eaaa-eef9-4ca7-876b-0020243f918c/6d0e8f1e-6a88-48a4-a555-9125d1ba970e.png',
        prompt:
          'Architectural visualization with modern or classical building design, detailed structural rendering with materials and spatial composition, professional architectural concept showcasing form and function, photorealistic or artistic architectural illustration',
      },
      {
        url: 'https://media.easy-peasy.ai/4d4c028d-19f5-4c64-b412-6e4ce01f2981/d107b21f-b87f-48c2-9ad2-d39c5eb94c06.png',
        prompt:
          'Architectural visualization with modern or classical building design, detailed structural rendering with materials and spatial composition, professional architectural concept showcasing form and function, photorealistic or artistic architectural illustration',
      },
    ],
  },
  {
    slug: 'character',
    name: 'Character',
    header: "Design and customize your character's appearance",
    seo_description:
      'Generate your own character appearance with our AI. Perfect for artists, game developers, and storytellers.',
    description:
      'Create your own character appearance with our AI. Bring your ideas to life with our collection of character styles.',
    isArt: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/0d49fe84-a085-4c29-b4a1-c105bdd1cf8e/2973694c-e9f1-4f1d-b7f7-e0e846edea71.png',
        prompt:
          'Detailed character design with distinctive personality and visual appeal, unique character concept with expressive features and costume design, professional character art suitable for games, animation or illustration, memorable protagonist or supporting character with clear identity',
      },
    ],
  },
  // baby
  {
    slug: 'baby',
    name: 'Baby',
    header: 'Create Your Own Baby Design',
    seo_description:
      'Generate your own baby design with our AI. Perfect for artists, designers, and parents.',
    description:
      'Create your own baby design with our AI. Bring your ideas to life with our collection of baby styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 864x496, muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/baby-hero.mp4',
        prompt:
          'Adorable baby portrait with cherubic features and innocent expression, sweet infant photography capturing pure joy and wonder, soft lighting and gentle atmosphere perfect for nursery art, heartwarming baby illustration suitable for family keepsakes and announcements',
      },
    ],
  },
  {
    slug: 'book-cover',
    name: 'Book Cover',
    header: 'Design Your Own Book Cover',
    seo_description:
      'Generate unique book cover designs with our AI. Perfect for authors, publishers, and book enthusiasts.',
    description:
      'Create captivating book cover designs with our AI. Bring your literary vision to life with our collection of book cover styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/dc685ffc-ce7b-4320-ab86-3037096cac55.png',
        prompt:
          'Professional book cover design with compelling visual storytelling, literary cover art with typography and imagery balanced for impact, genre-appropriate design aesthetic perfect for publishing, eye-catching cover that captures the essence and mood of the story',
      },
    ],
  },
  {
    slug: 'book-illustration',
    name: 'Book Illustration',
    header: 'Create Your Own Book Illustrations',
    seo_description:
      'Generate beautiful book illustrations with our AI. Perfect for authors, publishers, and illustrators.',
    description:
      'Create enchanting book illustrations with our AI. Bring your stories to life with our collection of illustration styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/87f12257-e771-4846-beff-8f077f29a758/fc5f908f-9e34-444d-b0ed-217c547241fe.webp',
        prompt:
          "Enchanting children's book illustration with whimsical characters and magical storytelling, colorful storybook art perfect for young readers, charming narrative illustration style with imaginative details, heartwarming picture book aesthetic suitable for publishing",
      },
    ],
  },
  {
    slug: 'outfit',
    name: 'Outfit',
    header: 'Design Your Own Outfit',
    seo_description:
      'Generate unique outfit designs with our AI. Perfect for fashion designers, stylists, and fashion enthusiasts.',
    description:
      'Create stylish and innovative outfit designs with our AI. Bring your fashion ideas to life with our collection of clothing styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3dded040-05e0-4f31-ae28-069f6cc406c4.png',
        prompt:
          'Fashion outfit design with coordinated clothing pieces and accessories, trendy ensemble visualization with modern styling and color harmony, complete look from head to toe perfect for fashion inspiration, professional outfit presentation suitable for style guides and lookbooks',
      },
    ],
  },
  {
    slug: 'youtube-thumbnail',
    name: 'YouTube Thumbnail',
    header: 'Create Your Own YouTube Thumbnail',
    seo_description:
      'Generate eye-catching YouTube thumbnail designs with our AI. Perfect for content creators, vloggers, and marketers.',
    description:
      "Design compelling YouTube thumbnails with our AI. Boost your video's click-through rate with our collection of thumbnail styles.",
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/81ed2c56-bc5a-400e-b38b-b4d2230b700a.png',
        prompt:
          'Eye-catching YouTube thumbnail with bold typography and vibrant colors, clickable video preview design with engaging visual hooks, high-contrast composition perfect for attracting viewers, professional content creator thumbnail optimized for click-through rates',
      },
    ],
  },
  {
    slug: 'banner',
    name: 'Banner',
    header: 'Create Your Own Banner',
    seo_description:
      'Generate eye-catching banner designs with our AI. Perfect for marketers, event organizers, and social media managers.',
    description:
      'Design impactful banners with our AI. Enhance your online presence and marketing campaigns with our collection of banner styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/f8775ef9-d116-4bb3-82ac-2bded24ae5e0/8147e785-5cb2-417f-b85b-591c1e480a76.jpg',
        prompt:
          'Professional web banner design with compelling call-to-action and visual appeal, marketing banner with brand messaging and promotional graphics, eye-catching header or footer design perfect for websites, impactful advertising banner optimized for conversions',
      },
    ],
  },
  {
    slug: 'sprite-sheet',
    name: 'Sprite Sheet',
    header: 'AI Sprite Sheet Generator',
    seo_description:
      'Generate game-ready animated sprite sheets with our AI. Create character animations, walk cycles, and action sequences for 2D games.',
    description:
      'Generate game-ready animated sprite sheets from text descriptions. Create character animations with customizable grid sizes and actions for your 2D games.',
    skipTitle: true,
    ctaUrl: '/sprite-generator',
    images: [
      {
        url: 'https://media.easy-peasy.ai/assets/showcase/006-bamboo-panda-warrior-studio-ghibli-inspi.gif',
        prompt:
          'bamboo panda warrior, Studio Ghibli inspired, isometric action RPG animation',
      },
      {
        url: 'https://media.easy-peasy.ai/assets/showcase/001-lavender-wolf-archer-pastel-dreamlike-is.gif',
        prompt:
          'lavender wolf archer, pastel dreamlike, isometric action RPG animation',
      },
      {
        url: 'https://media.easy-peasy.ai/assets/showcase/042-tiny-samurai-cat-studio-ghibli-inspired-.gif',
        prompt:
          'tiny samurai cat, Studio Ghibli inspired, isometric action RPG animation',
      },
      {
        url: 'https://media.easy-peasy.ai/assets/showcase/037-jolly-mushroom-knight-8-bit-classic-isom.gif',
        prompt:
          'jolly mushroom knight, 8-bit classic, isometric action RPG animation',
      },
    ],
  },
  {
    slug: 'caricature',
    name: 'Caricature',
    header: 'Create Your Own Caricature',
    seo_description:
      'Generate hilarious and exaggerated caricature designs with our AI. Perfect for entertainers, artists, and anyone looking for a fun portrait.',
    description:
      'Design amusing and exaggerated caricatures with our AI. Bring out the unique features and personalities in portraits with our collection of caricature styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/caricature-hero.mp4',
        prompt:
          'Humorous caricature drawing with exaggerated facial features and playful distortion, comic portrait art emphasizing distinctive characteristics, satirical illustration style with bold lines and expressive details, entertaining character portrait perfect for gifts and entertainment',
      },
      {
        url: 'https://media.easy-peasy.ai/b791e96a-7bcf-4f3a-b333-2ae5374056a7/2531ac7b-6030-42b6-96d9-6de750ce0a36.png',
        prompt:
          'Realistic caricature drawing with accurate facial features and subtle distortion, professional portrait art emphasizing natural expression and subtle exaggeration, detailed illustration style with soft lines and subtle details, realistic character portrait perfect for portraits and profile pictures',
      },
    ],
  },
  {
    slug: 'scene',
    name: 'Scene',
    header: 'Create Your Own Scene',
    seo_description:
      'Generate captivating scene designs with our AI. Perfect for storytellers, filmmakers, and visual artists.',
    description:
      'Design immersive and detailed scenes with our AI. Bring your stories and visual concepts to life with our collection of scene styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a dolly-in tracking the figure, with rain, drifting steam and
        // rippling neon reflections,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/scene-hero.mp4',
        prompt:
          'Cinematic scene composition with environmental storytelling and atmospheric details, detailed setting visualization perfect for films and narratives, immersive location design with lighting and mood, dramatic moment captured in a visually compelling scene',
      },
    ],
  },
  {
    slug: 'mugshot',
    name: 'Mugshot',
    header: 'Create Your Own Mugshot',
    seo_description:
      'Generate realistic mugshot designs with our AI. Perfect for filmmakers, crime novelists, and visual artists exploring law enforcement themes.',
    description:
      'Design authentic-looking mugshots with our AI. Bring characters to life in a law enforcement context with our collection of mugshot styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: the still was generated with GPT Image 2 Medium and
        // brought to life with FLUX 3 Image (720p, 5s, 1:1). Muted, trimmed to
        // a blink-free loop point and re-encoded to 720x720 for page weight —
        // `StylePreviewMedia` renders any .mp4 as an autoplaying muted loop.
        url: 'https://media.easy-peasy.ai/landing/image-styles/mugshot.mp4',
        prompt:
          'Realistic mugshot of a rugged middle-aged man with a stern expression',
      },
    ],
  },
  {
    slug: 'face',
    name: 'Face',
    header: 'Create Your Own Face Portrait',
    seo_description:
      'Generate stunning face portrait designs with our AI. Perfect for personal profiles, social media, and professional headshots.',
    description:
      'Design beautiful and realistic face portraits with our AI. Create professional-looking headshots and profile pictures with our collection of portrait styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/272385a6-5f18-40b3-8140-5dfc58a7b925/494a8b73-890e-4c50-abba-91eb72c1fd6a.png',
        prompt:
          'Detailed human face portrait with expressive features and natural skin tones, photorealistic facial rendering with careful attention to eyes, nose and mouth, intimate close-up portrait capturing personality and emotion, professional headshot quality perfect for profiles',
      },
    ],
  },
  {
    slug: 'human',
    name: 'Human',
    header: 'Create Realistic Human Figures',
    seo_description:
      'Generate striking, realistic human figures with our AI. Perfect for creating lifelike people tailored to your exact specifications in seconds.',
    description:
      'With our AI human generator, we create striking, realistic human figures tailored to your specifications, all in a matter of seconds.',
    skipTitle: false,
    isPhoto: true,
    search_query: 'human photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/dbd8932b-7c7f-4d90-a667-dbd38c5452eb/0db7a4f1-a093-4c67-bc3a-6f5344ced872.png',
        prompt:
          'A photorealistic portrait of a young woman with natural lighting, subtle makeup, and a genuine expression, showcasing lifelike skin texture and details',
      },
    ],
  },
  {
    slug: 'food',
    name: 'Food',
    header: 'Create Your Own Food Image',
    isPhoto: true,
    search_query: 'food photography',
    seo_description:
      'Generate mouth-watering food designs with our AI. Perfect for food bloggers, restaurateurs, and culinary enthusiasts.',
    description:
      'Design appetizing and visually stunning food images with our AI. Bring your culinary creations to life with our collection of food photography styles.',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a slow push-in with rising steam over the bowl,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/food-hero.mp4',
        prompt: 'Gourmet burger with melted cheese and fresh vegetables',
      },
    ],
  },
  {
    slug: 'yearbook',
    name: 'Yearbook Photo',
    header: 'Create Your Own Yearbook Photo',
    seo_description:
      'Generate nostalgic yearbook photo designs with our AI. Perfect for educators, students, and anyone looking to recreate school memories.',
    description:
      'Design authentic-looking yearbook photos with our AI. Capture the essence of school days and create memorable portraits with our collection of yearbook photo styles.',
    skipTitle: true,
    isPhotoPack: false,
    images: [
      {
        url: 'https://media.easy-peasy.ai/f95969b3-4cad-4f6c-a82d-f8d946337191/da3b452e-c27b-483c-938c-e4148098ffc1.png',
        prompt:
          'Classic yearbook photo of a smiling high school student with a blue background',
      },
    ],
  },
  {
    slug: 'graduation-photo',
    name: 'Graduation Photo',
    header: 'Create Your Own Graduation Photo',
    seo_description:
      'Generate memorable graduation photo designs with our AI. Perfect for students, educators, and proud families celebrating academic achievements.',
    description:
      'Design authentic-looking graduation photos with our AI. Capture the pride and accomplishment of this significant milestone with our collection of graduation photo styles.',
    skipTitle: true,
    isPhotoPack: false,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/graduation-photo-hero.mp4',
        prompt:
          'Proud graduate in cap and gown, holding a diploma, with a beaming smile against a university backdrop',
      },
    ],
  },
  {
    slug: 'vintage-photo',
    name: 'Vintage Photo',
    header: 'Create Your Own Vintage Photo',
    seo_description:
      'Generate nostalgic vintage photo designs with our AI. Perfect for history enthusiasts, retro lovers, and anyone looking to recreate the charm of bygone eras.',
    description:
      'Design authentic-looking vintage photos with our AI. Capture the essence of past decades and create timeless portraits with our collection of vintage photo styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/498c5b21-8c77-4294-844b-0c2770d658ec/8390548d-509a-460d-9cb6-41cff31fb786.png',
        prompt:
          'Black and white photograph of a 1950s diner with classic cars parked outside',
      },
    ],
  },
  {
    slug: 'christmas-photo',
    name: 'Christmas Photo',
    header: 'Create Your Own Christmas Photo',
    additional_title: ' 2026',
    seo_description:
      'Generate festive Christmas photo designs with our AI. Perfect for holiday cards, social media posts, and capturing the magic of the season.',
    description:
      'Design heartwarming Christmas photos with our AI. Bring the joy and warmth of the holidays to life with our collection of Christmas photo styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/7811b6b1-5b01-4ae3-9360-27ae14a10b8f/52ff27f2-c756-40a8-9442-4ad04a7d95ef.png',
        prompt:
          'Cozy family Christmas photo in front of a decorated tree with twinkling lights',
      },
    ],
  },
  {
    slug: 'christmas-card',
    name: 'Christmas Card',
    header: 'Create Your Own Christmas Card',
    additional_text: ' 2026',
    seo_description:
      'Generate festive Christmas card designs with our AI. Perfect for sending holiday greetings to family, friends, and business associates.',
    description:
      'Design beautiful Christmas cards with our AI. Create personalized holiday greetings with our collection of Christmas card styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/87236829-4cef-42e4-85ed-b06544bc6cc0.png',
        prompt:
          'Festive Christmas card design with snow-covered pine trees and twinkling lights',
      },
    ],
  },
  {
    slug: 'muppet',
    name: 'Muppet',
    header: 'Create Your Own Muppet Character',
    seo_description:
      "Generate unique Muppet-style character designs with our AI. Perfect for puppet enthusiasts, children's entertainment creators, and fans of Jim Henson's creations.",
    description:
      'Design colorful and expressive Muppet-inspired characters with our AI. Bring your imaginative puppet ideas to life with our collection of Muppet-style designs.',
    isPhoto: true,
    search_query: 'turn this photo into muppet.',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/muppet-hero.mp4',
        prompt:
          'Cheerful green Muppet character with big eyes and fluffy orange hair',
      },
    ],
  },
  {
    slug: 'cake',
    name: 'Cake',
    header: 'Create Your Own Cake Design',
    seo_description:
      'Generate mouthwatering cake designs with our AI. Perfect for bakers, party planners, and dessert enthusiasts looking to visualize their sweet creations for birthdays, weddings, and other special occasions.',
    description:
      'Design delectable and visually stunning cakes with our AI. Bring your confectionery dreams to life with our collection of cake design styles, including birthday cakes, wedding cakes, and more.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/cake-hero.mp4',
        prompt:
          'Elegant three-tier wedding cake with white fondant and delicate sugar flowers',
      },
    ],
  },
  {
    slug: 'costume',
    name: 'Costume',
    header: 'Create Your Own Costume Design',
    seo_description:
      'Generate unique and creative costume designs with our AI. Perfect for cosplayers, costume designers, Halloween enthusiasts, and anyone looking to bring their imaginative character concepts to life.',
    description:
      'Design eye-catching and detailed costumes with our AI. From fantasy and sci-fi to historical and pop culture-inspired outfits, bring your costume ideas to reality with our diverse collection of costume design styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/73483fbe-1001-4871-b932-cee579084c0f/2fe64afb-3d90-4f6e-a035-ab8482cb5887.png',
        prompt:
          'Intricate steampunk costume with brass gears, leather accents, and a top hat',
      },
    ],
  },
  {
    slug: 'cat',
    name: 'Cat',
    header: 'Create Your Own Cat Design',
    seo_description:
      'Generate adorable and unique cat designs with our AI. Perfect for pet lovers, illustrators, and anyone looking to create charming feline characters for various projects.',
    description:
      'Design cute and expressive cat characters with our AI. From fluffy house cats to majestic wild felines, bring your cat ideas to life with our diverse collection of cat design styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied talking-video clip (already square), muted
        // and re-encoded to 720x720. Short at 1.5s, so it loops quickly.
        url: 'https://media.easy-peasy.ai/landing/image-styles/cat.mp4',
        prompt: 'Playful orange tabby cat with green eyes and a fluffy tail',
      },
    ],
  },
  {
    slug: 'dog',
    name: 'Dog',
    header: 'Create Your Own Dog Images',
    seo_description:
      'Generate realistic and charming dog images with our AI. Perfect for pet lovers, social media enthusiasts, and anyone looking to create beautiful pictures of dogs in various settings and poses.',
    description:
      'Create stunning and lifelike dog images with our AI. From playful puppies to noble breeds, capture the spirit and personality of dogs in beautiful photographs and illustrations.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/89df404c-cc75-4913-b1e6-c2a2d3402369/deea4948-8ffe-4d09-a1b6-a8828f27486b.png',
        prompt:
          "Beautiful dog portrait with realistic fur details and expressive eyes, charming canine photography capturing the personality and spirit of man's best friend, various breeds in natural or studio settings with professional pet photography quality",
      },
    ],
  },
  {
    slug: 'jewelry',
    name: 'Jewelry',
    header: 'Create Your Own Jewelry Design',
    isPhoto: true,
    seo_description:
      'Generate stunning and unique jewelry designs with our AI. Perfect for jewelers, designers, and anyone looking to visualize beautiful accessories for various occasions and styles.',
    description:
      'Design exquisite and eye-catching jewelry pieces with our AI. From elegant necklaces to intricate rings, bring your jewelry ideas to life with our diverse collection of jewelry design styles.',
    images: [
      {
        url: 'https://media.easy-peasy.ai/52fb00f0-7182-4994-a5b8-e7f030d006ba/ae718772-cae2-4dcb-a917-b0638c0ca2e2.png',
        prompt:
          'Exquisite jewelry design with precious gemstones and fine metalwork, luxury accessory visualization with intricate details and brilliant sparkle, professional product photography quality showcasing craftsmanship, elegant rings, necklaces or bracelets with premium aesthetic',
      },
    ],
  },
  {
    slug: 'linkedin-profile-picture',
    name: 'LinkedIn Profile Picture',
    header: 'Create Your Professional LinkedIn Profile Picture',
    seo_description:
      'Generate a polished and professional LinkedIn profile picture with our AI. Perfect for job seekers, entrepreneurs, and professionals looking to enhance their online presence.',
    description:
      'Design a professional and approachable LinkedIn profile picture with our AI. From corporate headshots to creative industry portraits, create the perfect image to represent your personal brand and make a great first impression in the professional world.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8a0216f0-7805-4842-af0a-059a3f4cdd33.png',
        prompt:
          'Professional LinkedIn headshot with approachable expression and business attire, polished corporate portrait against clean background, confident and friendly demeanor perfect for professional networking, high-quality profile picture optimized for career advancement',
      },
    ],
  },
  {
    slug: 'graffiti',
    name: 'Graffiti',
    header: 'Create Your Own Graffiti Art',
    seo_description:
      'Generate vibrant and edgy graffiti designs with our AI. Perfect for urban artists, designers, and anyone looking to create bold street art-inspired visuals.',
    description:
      'Design eye-catching and expressive graffiti artwork with our AI. From colorful tags to intricate murals, bring your street art ideas to life with our diverse collection of graffiti styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2024-10-05T10:27:46.987Z.jpg',
        prompt:
          'Urban graffiti art with bold spray paint aesthetics and vibrant street art colors, edgy hip-hop culture visual with dynamic lettering and wild style, authentic street art atmosphere with layered tags and murals, rebellious artistic expression perfect for urban design',
      },
    ],
  },
  {
    slug: 'product-design',
    name: 'Product Design',
    header: 'Create Your Own Product Design',
    seo_description:
      'Generate innovative and attractive product designs with our AI. Perfect for designers, entrepreneurs, and companies looking to visualize new product concepts across various industries.',
    description:
      'Design cutting-edge and functional product concepts with our AI. From sleek electronics to ergonomic furniture, bring your product ideas to life with our diverse collection of design styles and approaches.',
    skipTitle: true,
    search_query: 'product photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b91806c4-01aa-4307-a30a-666c657bc7a7.png',
        prompt:
          'Modern product design visualization with sleek industrial aesthetics, innovative consumer product concept with ergonomic form and premium materials, professional 3D rendering showcasing functionality and beauty, commercial product photography quality perfect for marketing',
      },
    ],
  },
  {
    slug: 'bible-art',
    name: 'Bible Art',
    header: 'Create Inspiring Bible Art',
    seo_description:
      'Generate beautiful and meaningful Bible-inspired artwork with our AI. Perfect for religious organizations, spiritual individuals, and artists seeking to create faith-based visuals.',
    description:
      'Design inspiring and reverent Bible-themed artwork with our AI. From classic biblical scenes to modern interpretations of scripture, bring sacred texts to life with our diverse collection of artistic styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted, 960px wide.
        url: 'https://media.easy-peasy.ai/landing/image-styles/bible-art-hero.mp4',
        prompt:
          'Jesus Christ the Good Shepherd holding a little lamb tenderly in his arms, standing on a hillside at golden hour sunset, warm divine light rays breaking through dramatic clouds above, lush green pasture with sheep grazing in the background, rich oil painting style with visible brushstrokes, classical Renaissance color palette with deep golds and warm earth tones, cinematic composition, ultra detailed masterpiece',
      },
    ],
  },
  {
    slug: 'sketch',
    name: 'Sketch',
    header: 'Create Your Own Sketch',
    seo_description:
      'Generate beautiful pencil sketches and drawings with our AI. Perfect for artists, illustrators, and anyone looking to create stunning hand-drawn style artwork.',
    description:
      'Transform your ideas into expressive pencil sketches with our AI. From quick doodles to detailed drawings, bring your artistic vision to life with our diverse sketching styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/8315c491-20ea-47ec-9ea4-87cce0a4adeb/c84ad530-b433-49e1-ba3f-6b94f08f994f.png',
        prompt:
          "Hand-drawn pencil sketch with loose artistic linework and expressive marks, quick gestural drawing capturing form and movement, artist's preliminary study with visible construction lines, raw sketching aesthetic perfect for concept development and illustration",
      },
    ],
  },
  {
    slug: 'house',
    name: 'House',
    header: 'Create Your Own House Design',
    seo_description:
      'Generate stunning house and architectural designs with our AI. Perfect for architects, real estate professionals, and homeowners visualizing their dream homes.',
    description:
      'Design beautiful and functional houses with our AI. From modern minimalist homes to classic architecture, bring your residential visions to life with our diverse collection of house design styles.',
    isPhoto: true,
    search_query: 'modern house exterior design',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a slow dolly-in along the pool,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/house-hero.mp4',
        prompt:
          'Modern luxury house with large windows, clean lines, and an infinity pool overlooking a scenic landscape',
      },
    ],
  },
  {
    slug: 'home-exterior-design',
    name: 'Home Exterior Design',
    header: 'Design Your Dream Home Exterior',
    seo_description:
      'Generate stunning home exterior designs with our AI. Perfect for architects, homeowners, and real estate professionals visualizing curb appeal.',
    description:
      'Create beautiful home exteriors with our AI. From modern facades to classic architectural styles, bring your dream home exterior to life.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a slow dolly-in up the lit path toward the entry,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/home-exterior-hero.mp4',
        prompt:
          'Modern luxury home exterior with clean lines, large windows, and elegant landscaping',
      },
    ],
  },
  {
    slug: 'landscape-design',
    name: 'Landscape Design',
    header: 'Create Beautiful Landscape Designs',
    seo_description:
      'Generate stunning landscape and garden designs with our AI. Perfect for landscape architects, garden designers, and homeowners planning their outdoor spaces.',
    description:
      'Design breathtaking outdoor spaces with our AI. From elegant gardens to modern landscapes, bring your landscaping vision to life with our diverse collection of design styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/f5b9613e-7853-4170-84fd-2015606585bf/2024-09-15T10:22:31.236Z.jpg',
        prompt:
          'Modern landscape design with layered gardens, water features, and natural stone elements in a harmonious outdoor setting',
      },
    ],
  },
  {
    slug: 'fusion',
    name: 'Fusion',
    header: 'Create Unique Fusion Art',
    seo_description:
      'Generate innovative fusion artwork that blends different styles and concepts with our AI. Perfect for artists and creators looking to explore unique combinations.',
    description:
      'Design groundbreaking fusion art with our AI. Combine different artistic styles, cultural elements, and creative concepts to create something truly unique and captivating.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/040b061a-ed3c-495c-8b49-450390a2628d/2e2ea44d-6015-41f2-88e3-95c1b2144c64.png',
        prompt:
          'Creative fusion artwork combining multiple elements or creatures, imaginative hybrid design blending different visual concepts, surreal mashup illustration with seamless integration, unique composite image perfect for creative expression and artistic experimentation',
      },
    ],
  },
  {
    slug: 'doodle',
    name: 'Doodle',
    header: 'Create Your Own Doodle Art',
    seo_description:
      'Generate fun and expressive doodle artwork with our AI. Perfect for creative expression, casual sketching, and adding a personal touch to your designs.',
    description:
      'Design playful and spontaneous doodle art with our AI. From simple scribbles to intricate doodle compositions, let your creativity flow with our collection of doodling styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 1:1) as the doodles coming alive in place with a
        // hand-drawn line boil (first second trimmed: the model colourises
        // the mono sheet there, which would flicker on every loop),
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/doodle-hero.mp4',
        prompt:
          'a cute and simple doodle drawing showcasing the importance of life.',
      },
    ],
  },
  {
    slug: 'stadium',
    name: 'Stadium',
    header: 'Design Your Dream Stadium',
    seo_description:
      'Generate impressive stadium and sports venue designs with our AI. Perfect for architects, sports organizations, and event planners visualizing large-scale athletic facilities.',
    description:
      'Design spectacular sports venues with our AI. From modern arenas to classic ballparks, create stunning stadium concepts with our collection of architectural styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted. Encoded at
        // 800px/CRF31 rather than the usual 960/29 — the fireworks and crowd
        // motion made a 960px version 3MB, twice any other hero.
        url: 'https://media.easy-peasy.ai/landing/image-styles/stadium-hero-lite.mp4',
        prompt:
          'Modern football stadium with retractable roof, dramatic lighting, and sweeping architectural lines at sunset',
      },
    ],
  },
  {
    slug: 'patch',
    name: 'Patch',
    header: 'Create Your Own Patch Design',
    seo_description:
      'Generate unique embroidered patch designs with our AI. Perfect for customizing apparel, accessories, and creating memorable insignias.',
    description:
      'Design eye-catching embroidered patches with our AI. From military-style badges to fun decorative patches, create distinctive designs that stand out.',
    skipTitle: true,
    search_query: 'embroidered patches',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a28471e4-fe92-47ab-a126-3aa4bf49d296.png',
        prompt:
          'Embroidered military-style patch with eagle emblem and bold text',
      },
    ],
  },
  {
    slug: 'planet',
    name: 'Planet',
    header: 'Create Your Own Planetary Designs',
    seo_description:
      'Generate stunning planetary and space-themed artwork with our AI. Perfect for sci-fi enthusiasts, astronomers, and digital artists.',
    description:
      'Design breathtaking planets and celestial bodies with our AI. From gas giants to rocky worlds, create unique planetary concepts with our collection of cosmic styles.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a slow axial rotation with churning
        // storm bands and glinting rings, muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/planet-hero.mp4',
        prompt:
          'A ringed gas giant planet with swirling storms and vibrant colors, viewed from space',
      },
    ],
  },
  {
    slug: 'silhouette',
    name: 'Silhouette',
    header: 'Create Striking Silhouette Art',
    seo_description:
      'Generate dramatic silhouette artwork with our AI. Perfect for creating bold, high-contrast designs and artistic compositions.',
    description:
      'Design captivating silhouette art with our AI. From elegant profiles to dramatic scenes, create stunning high-contrast artwork with our collection of silhouette styles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/8c156ed1-8f26-4ec6-9966-e466c17ad219/3b89bb61-7b9a-4e03-b20d-7fc0eee6e4ec.png',
        prompt:
          'Dramatic silhouette art with strong contrast and recognizable shapes, black figure against bright background creating powerful visual impact, minimalist shadow design emphasizing form and gesture, elegant outline illustration perfect for logos and artistic statements',
      },
    ],
  },
  {
    slug: 'postcard',
    name: 'Postcard',
    header: 'Create Your Own Vintage Postcards',
    seo_description:
      'Generate nostalgic vintage postcard designs with our AI. Perfect for creating retro travel memorabilia, greetings, and collectible-style artwork.',
    description:
      'Design charming vintage postcards with our AI. From classic travel scenes to retro greetings, create unique postcard designs that capture the essence of a bygone era.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/d01de08a-e5de-443f-ae8c-c96e7a476127/e2036c8b-984e-4141-a911-a19a8338b66b.png',
        prompt:
          'Vintage style travel postcard with retro typography and scenic landscape',
      },
    ],
  },
  {
    slug: 'family-crest',
    name: 'Family Crest',
    header: 'Create Your Own Family Crest',
    seo_description:
      'Generate unique and personalized family crests with our AI. Perfect for genealogy enthusiasts, family reunions, and heraldic designs.',
    description:
      'Design distinctive family crests with our AI. From traditional heraldic symbols to modern interpretations, create meaningful emblems that represent your family legacy.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/559ff162-fd9f-47d0-865c-91cfab4b958d.png',
        prompt:
          'A noble family crest with a shield, lions, and intricate heraldic designs',
      },
    ],
  },
  {
    slug: 'stained-glass',
    name: 'Stained Glass',
    header: 'Create Stunning Stained Glass Art',
    seo_description:
      'Generate beautiful stained glass artwork with our AI. Perfect for creating colorful, luminous designs inspired by cathedral windows and decorative glass art.',
    description:
      'Design mesmerizing stained glass patterns with our AI. From gothic cathedral windows to modern decorative pieces, create radiant artwork with rich colors and intricate leading patterns.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/9c238476-82e7-4de8-8151-f026dddbaf4c/fb07faa9-b757-4ef5-922f-48e0a057395c.png',
        prompt:
          'A vibrant stained glass window with geometric patterns and jewel tones',
      },
    ],
  },
  {
    slug: 'van-gogh',
    name: 'Van Gogh',
    header: 'Create Art in Van Gogh Style',
    seo_description:
      'Generate artwork inspired by Vincent van Gogh with our AI. Perfect for creating post-impressionist pieces with bold colors and expressive brushstrokes.',
    description:
      'Design artwork in the distinctive style of Vincent van Gogh with our AI. Create pieces featuring bold colors, dramatic brushstrokes, and the emotional intensity characteristic of the post-impressionist master.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/van-gogh-hero.mp4',
        prompt:
          'A starry night landscape in the style of Van Gogh with swirling clouds and cypress trees',
      },
    ],
  },
  {
    slug: 'warhol',
    name: 'Warhol',
    header: 'Create Pop Art in Warhol Style',
    seo_description:
      'Generate pop art inspired by Andy Warhol with our AI. Perfect for creating bold, colorful pieces with repetitive patterns and cultural commentary.',
    description:
      'Design artwork in the iconic style of Andy Warhol with our AI. Create vibrant pop art pieces featuring bold colors, repetitive patterns, and contemporary cultural elements.',
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/4071978a-4ad6-4fda-8f9f-c7d689ed8bea/63c8763d-7250-4cf2-8077-8fad625a256b.png',
        prompt:
          'A pop art portrait in Warhol style with bright colors and repeated patterns',
      },
    ],
  },
  {
    slug: 'picasso',
    name: 'Picasso',
    header: 'Create Art in Picasso Style',
    seo_description:
      'Generate artwork inspired by Pablo Picasso with our AI. Perfect for creating cubist pieces with abstract forms and multiple perspectives.',
    description:
      'Design artwork in the revolutionary style of Pablo Picasso with our AI. Create pieces featuring geometric shapes, multiple perspectives, and the bold experimentation of cubism.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1) — the cubist planes shift and breathe
        // rather than the subject moving, which keeps it reading as a painting.
        url: 'https://media.easy-peasy.ai/landing/image-styles/picasso-hero.mp4',
        prompt:
          'A cubist portrait in Picasso style with geometric shapes and multiple perspectives',
      },
    ],
  },
  {
    slug: 'da-vinci',
    name: 'Leonardo da Vinci',
    header: 'Create Art in da Vinci Style',
    seo_description:
      'Generate artwork inspired by Leonardo da Vinci with our AI. Perfect for creating Renaissance-style pieces with classical composition and sfumato technique.',
    description:
      'Design artwork in the masterful style of Leonardo da Vinci with our AI. Create pieces featuring classical composition, subtle gradations, and the refined techniques of the Renaissance.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7877773d-8b30-4df6-95d4-758a62f46087.webp',
        prompt:
          'A portrait in da Vinci style with subtle shadows and Renaissance composition',
      },
    ],
  },
  {
    slug: 'monet',
    name: 'Claude Monet',
    header: 'Create Art in Monet Style',
    seo_description:
      'Generate artwork inspired by Claude Monet with our AI. Perfect for creating impressionist landscapes with soft light and atmospheric effects.',
    description:
      'Design artwork in the impressionist style of Claude Monet with our AI. Create pieces featuring natural light, atmospheric effects, and the loose brushwork characteristic of impressionism.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e636d26c-472b-48c3-b530-d605f6ba2d34.webp',
        prompt:
          'A water lily pond in Monet style with impressionist brushwork and light effects',
      },
    ],
  },
  {
    slug: 'dali',
    name: 'Salvador Dali',
    header: 'Create Art in Dali Style',
    seo_description:
      'Generate artwork inspired by Salvador Dali with our AI. Perfect for creating surrealist pieces with dreamlike imagery and symbolic elements.',
    description:
      'Design artwork in the surrealist style of Salvador Dali with our AI. Create pieces featuring dreamlike landscapes, melting objects, and the symbolic imagery of surrealism.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/c2e95c36-80cb-40d5-8392-9a3e6153ef62/90fb8f46-4ab2-4df8-8037-efa3837341a4.png',
        prompt:
          'A surrealist landscape in Dali style with melting clocks and dreamlike elements',
      },
    ],
  },
  {
    slug: 'pollock',
    name: 'Jackson Pollock',
    header: 'Create Art in Pollock Style',
    seo_description:
      'Generate artwork inspired by Jackson Pollock with our AI. Perfect for creating abstract expressionist pieces with dynamic drip painting techniques.',
    description:
      'Design artwork in the abstract expressionist style of Jackson Pollock with our AI. Create pieces featuring spontaneous drips, splatters, and the energetic movement of action painting.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c52f9c3a-cb08-4a17-8cf7-7f736fc104c8.webp',
        prompt:
          'An abstract expressionist painting in Pollock style with dynamic drips and splatters',
      },
    ],
  },
  {
    slug: 'rothko',
    name: 'Mark Rothko',
    header: 'Create Art in Rothko Style',
    seo_description:
      'Generate artwork inspired by Mark Rothko with our AI. Perfect for creating color field paintings with large blocks of subtle color variations.',
    description:
      'Design artwork in the abstract style of Mark Rothko with our AI. Create pieces featuring large color fields, subtle gradients, and the emotional depth of color field painting.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9293b072-4f91-416c-9186-fdab1d469fbe.webp',
        prompt:
          'A color field painting in Rothko style with large blocks of subtle color variations',
      },
    ],
  },
  {
    slug: 'kandinsky',
    name: 'Kandinsky',
    header: 'Create Art in Kandinsky Style',
    seo_description:
      'Generate artwork inspired by Wassily Kandinsky with our AI. Perfect for creating abstract expressionist pieces with vibrant colors and geometric forms.',
    description:
      'Design artwork in the abstract style of Wassily Kandinsky with our AI. Create pieces featuring vibrant colors, geometric forms, and the emotional intensity of abstract expressionism.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b7325578-d1ad-4a8f-b995-092a48e3526a.webp',
        prompt:
          'An abstract expressionist painting in Kandinsky style with vibrant colors and geometric forms',
      },
    ],
  },
  {
    slug: 'klimt',
    name: 'Gustav Klimt',
    header: 'Create Art in Klimt Style',
    seo_description:
      'Generate artwork inspired by Gustav Klimt with our AI. Perfect for creating impressionist pieces with soft light and atmospheric effects.',
    description:
      'Design artwork in the impressionist style of Gustav Klimt with our AI. Create pieces featuring natural light, atmospheric effects, and the refined techniques of impressionism.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/ebd06dd7-6341-4a09-9b2d-a807a05aef35/5927f33b-222c-4075-a642-8ed4da5c6463.png',
        prompt:
          'A portrait in Klimt style with soft light and atmospheric effects',
      },
    ],
  },
  {
    slug: 'hokusai',
    name: 'Hokusai',
    header: 'Create Art in Hokusai Style',
    seo_description:
      'Generate artwork inspired by Hokusai with our AI. Perfect for creating ukiyo-e style prints with dynamic brushwork and symbolic elements.',
    description:
      'Design artwork in the ukiyo-e style of Hokusai with our AI. Create pieces featuring dynamic brushwork, symbolic elements, and the vibrant colors of traditional Japanese art.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8e09548d-be34-430b-8ba7-769dc785ddb4.webp',
        prompt:
          'A ukiyo-e style print in Hokusai style with dynamic brushwork and symbolic elements',
      },
    ],
  },
  {
    slug: 'vector',
    name: 'Vector (SVG)',
    header: 'Create Vector Art',
    seo_description:
      'Generate clean, scalable vector-style artwork with our AI. Perfect for logos, illustrations, and graphics that need crisp lines and shapes.',
    description:
      'Create professional vector-style artwork with our AI. Design illustrations with clean lines, geometric shapes, and smooth gradients ideal for modern digital graphics.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/448cec1e-b4f0-4a71-9ebf-c20ef24df757.svg',
        prompt:
          'Minimalist vector illustration of a mountain landscape at sunset with geometric shapes and clean lines',
      },
    ],
  },
  {
    slug: 'cyborg',
    name: 'Cyborg',
    header: 'Create Cyborg Art',
    seo_description:
      'Generate stunning cyborg-themed artwork with our AI. Perfect for creating futuristic human-machine hybrid designs.',
    description:
      'Design captivating cyborg artwork with our AI. Create stunning visuals that blend human and machine elements in a seamless, futuristic style.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/c660d516-a5e5-4ba1-8cb4-d1c9e20981bd/12381bb4-a46b-41e1-8cec-02f5f04974a9.png',
        prompt:
          'Futuristic cyborg portrait with glowing cybernetic enhancements and sleek metallic elements',
      },
    ],
  },
  {
    slug: 'synthwave',
    name: 'Synthwave',
    header: 'Create Retro-Futuristic Synthwave Art',
    seo_description:
      'Generate stunning synthwave artwork with our AI. Perfect for creating 80s-inspired retro-futuristic designs with neon aesthetics.',
    description:
      'Design vibrant synthwave art with our AI. Create retro-futuristic scenes featuring neon grids, sunsets, and chrome text in the iconic 80s aesthetic.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/7abbb8fb-1a28-4678-a932-515d1daca6c1/9aabd0a3-1f62-4001-83e8-22145bd5cb92.png',
        prompt:
          'Retro-futuristic synthwave landscape with neon grid horizon, chrome text, and purple sunset',
      },
    ],
  },
  {
    slug: 'neonpunk',
    name: 'Neonpunk',
    header: 'Create Neonpunk Art',
    seo_description:
      'Generate vibrant neonpunk artwork with our AI. Perfect for creating cyberpunk-inspired designs with bold neon colors and urban aesthetics.',
    description:
      'Design striking neonpunk art with our AI. Create futuristic urban scenes bathed in neon lights, featuring bold colors and cyberpunk elements.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/570a5fc3-f263-4456-aa2c-9771e4a3af98.webp',
        prompt:
          'Neonpunk cityscape with bright neon signs, holographic displays, and rain-slicked streets in a futuristic urban setting',
      },
    ],
  },
  {
    slug: 'analog',
    name: 'Analog',
    header: 'Create Analog-Style Photography',
    seo_description:
      'Generate vintage analog-style photos with our AI. Perfect for creating nostalgic film photography aesthetics with authentic grain and colors.',
    description:
      'Design timeless analog-style photos with our AI. Create images with the authentic look of film photography, complete with natural grain, light leaks, and vintage color palettes.',
    skipTitle: false,
    isPhoto: true,
    search_query: 'Analog Photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/99a7f61d-5b4f-4d5d-bcab-74c8e08688b5/f0cbee22-d954-425f-9c64-4ff9f39f2b28.png',
        prompt:
          'Vintage analog photograph of a street scene with film grain, warm tones, and subtle light leaks',
      },
    ],
  },
  {
    slug: 'product-photography',
    name: 'Product Photography',
    header: 'Create Professional Product Photos',
    seo_description:
      'Generate professional product photography with our AI. Perfect for e-commerce, marketing materials, and showcasing products in their best light.',
    description:
      'Create stunning product photos with our AI. Generate high-quality images that highlight product details with professional lighting and composition.',
    skipTitle: true,
    search_query: 'Product Photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3c4512f8-6bd5-4d8e-9fb6-2dc4c9a44d07.png',
        prompt:
          'Professional product photo of a luxury watch on white background with soft shadows and dramatic lighting',
      },
    ],
  },
  {
    slug: 'celebrity',
    name: 'Celebrity',
    header: 'Create Celebrity-Style Photos',
    seo_description:
      'Generate glamorous celebrity-style photos with our AI. Perfect for creating high-end portraits with professional lighting and Hollywood aesthetics.',
    description:
      'Design stunning celebrity-inspired photos with our AI. Create images that capture the glamour and sophistication of professional celebrity photography.',
    skipTitle: false,
    isPhoto: true,
    images: [
      {
        // Animated hero: supplied clip at its native 9:16, muted and capped
        // at 720px wide.
        url: 'https://media.easy-peasy.ai/landing/image-styles/celebrity-native.mp4',
        prompt:
          'Professional celebrity portrait with dramatic lighting, perfect makeup, and high-fashion styling against a studio backdrop',
      },
    ],
  },
  {
    slug: 'line-art',
    name: 'Line Art',
    header: 'Create Line Art Illustrations',
    seo_description:
      'Generate beautiful line art illustrations with our AI. Perfect for creating minimalist artwork, logos, and decorative designs.',
    description:
      'Create elegant line art illustrations with our AI. Generate clean, minimalist designs using simple continuous lines and geometric shapes.',
    skipTitle: true,
    search_query: 'Line Art drawing',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c21103c8-20b2-4e84-91c4-6d0f10df377b.webp',
        prompt:
          'Minimalist line art illustration of a face in profile using a single continuous line on white background',
      },
    ],
  },
  {
    slug: 'avatar',
    name: 'Avatar',
    header: 'Create Your Perfect AI Avatar',
    seo_description:
      'Generate stunning AI avatars and profile pictures with our AI. Perfect for social media, gaming profiles, and professional headshots with an artistic AI touch.',
    description:
      'Design personalized AI avatars that capture your essence. Create unique profile pictures that stand out with our advanced AI technology.',
    skipTitle: true,
    search_query: 'AI Avatar',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/d4999910-07fc-4893-bf0f-40ffdf3fc649.png',
        prompt:
          'Stylized AI avatar with artistic effects and professional appearance',
      },
    ],
  },
  {
    slug: 'background',
    name: 'Background Art',
    header: 'Create Custom AI Backgrounds',
    seo_description:
      'Generate stunning AI backgrounds for any purpose. Perfect for Zoom meetings, streaming, YouTube videos, and professional presentations.',
    description:
      'Design professional AI-generated backgrounds that make you stand out. Create unique backdrops for virtual meetings, content creation, and more.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/8d3de69c-7c4f-4540-8924-9e568e327381/7797b471-0ee2-4941-a0bd-4daef523cd87.png',
        prompt: 'Professional abstract background with modern design elements',
      },
    ],
  },
  {
    slug: 'concept-art',
    name: 'Concept Art',
    header: 'Create Stunning AI Concept Art',
    seo_description:
      'Generate professional concept art with AI. Perfect for game developers, film producers, and creative professionals needing quick visualization of ideas.',
    description:
      'Design impressive concept art with our AI. Quickly visualize characters, environments, and props for your creative projects.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e4c07dbc-6302-4c05-a8ac-3795be4cf386.png',
        prompt:
          'Futuristic sci-fi environment concept with detailed architectural elements',
      },
    ],
  },
  {
    slug: 'photo-restoration',
    name: 'Photo Restoration',
    header: 'Restore Old Photos with AI',
    seo_description:
      'Restore and enhance old photographs with our AI. Perfect for preserving family memories, historical photos, and damaged images with professional quality results.',
    description:
      'Breathe new life into old photographs with our AI restoration technology. Repair damage, enhance quality, and colorize black and white photos.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/1b05e3d1-819c-4559-893f-8d957c42da2f/7c66ebf8-e0cd-4fc6-a788-b1b3184fbffe.png',
        prompt:
          'Restored vintage family photograph with enhanced details and natural colors',
      },
    ],
  },
  {
    slug: 'game-assets',
    name: 'Game Assets',
    header: 'Create Game Assets with AI',
    seo_description:
      'Generate professional game assets with AI. Perfect for indie game developers, modders, and game designers needing quick, custom game art.',
    description:
      'Design custom game assets instantly with our AI. Create characters, items, textures, and environments for your game development projects.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/5dffd87a-87d0-42a1-869f-f0ce6beead6d/2024-09-19T16:48:53.210Z.jpg',
        prompt:
          'Fantasy RPG character items and weapons with detailed textures',
      },
    ],
  },
  {
    slug: 'fashion-design',
    name: 'Fashion Design',
    header: 'Create Innovative Fashion Designs',
    seo_description:
      'Generate unique fashion designs with AI. Perfect for fashion designers, brands, and retailers looking to visualize new clothing concepts.',
    description:
      'Design cutting-edge fashion with our AI. Create innovative clothing designs and visualize them on diverse models.',
    isPhoto: true,
    images: [
      {
        // Animated hero: reuses the clothing-design lookbook clip (a male and
        // a female model in one coordinated collection) — the two styles show
        // the same thing, so they share one file rather than a second upload.
        url: 'https://media.easy-peasy.ai/landing/image-styles/clothing-design-hero.mp4',
        prompt:
          'Contemporary fashion design on a professional model with studio lighting',
      },
    ],
  },
  {
    slug: 'nft',
    name: 'NFT Art',
    header: 'Create Unique NFT Artwork',
    seo_description:
      'Generate distinctive NFT artwork with AI. Perfect for crypto artists, collectors, and digital art enthusiasts looking to create unique pieces.',
    description:
      'Design original NFT artwork with our AI. Create unique digital art pieces ready for the NFT marketplace.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/062a9fb0-271c-4112-87dd-8c73d22d86da/8d00bcc0-824a-4056-ad4f-5d2e05f20eca.png',
        prompt: 'Abstract digital artwork with unique style and vibrant colors',
      },
    ],
  },
  {
    slug: 'packaging',
    name: 'Packaging Design',
    header: 'Create Professional Packaging Designs',
    seo_description:
      'Generate innovative packaging designs with AI. Perfect for product designers, brands, and manufacturers needing creative packaging solutions.',
    description:
      'Design eye-catching packaging with our AI. Create professional product packaging that stands out on shelves.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/packaging-hero.mp4',
        prompt:
          'Modern product packaging design with clean typography and bold colors',
      },
    ],
  },
  {
    slug: 'comic',
    name: 'Comic Creation',
    header: 'Create Comic Book Art with AI',
    seo_description:
      'Generate comic book style artwork with AI. Perfect for comic creators, storytellers, and artists looking to bring their stories to life.',
    description:
      'Design dynamic comic book art with our AI. Create compelling characters and scenes in classic comic book style.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/0b32291f-2aa7-4ab1-9c7a-62acdb747889/c75803e2-d188-4010-94ba-3271f128ba19.png',
        prompt:
          'Action-packed comic book panel with dramatic composition and effects',
      },
    ],
  },
  {
    slug: 'pattern',
    name: 'Pattern Art',
    header: 'Create Seamless Patterns with AI',
    seo_description:
      'Generate seamless patterns with AI. Perfect for textile designers, surface pattern artists, and creators needing unique repeating designs.',
    description:
      'Design beautiful seamless patterns with our AI. Create unique repeating designs for fabric, wallpaper, and more.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7c4edd10-08e4-4f2c-a762-b4804c93081b.png',
        prompt:
          'Elegant seamless pattern with botanical elements and soft colors',
      },
    ],
  },
  {
    slug: 'character-design',
    name: 'Character Design',
    header: 'Create Unique Character Designs',
    seo_description:
      'Generate original character designs with AI. Perfect for animators, game designers, and storytellers needing unique character concepts.',
    description:
      'Design compelling characters with our AI. Create unique personalities for games, animations, and stories.',
    skipTitle: true,
    search_query: 'animated character',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/86127a91-f66b-4add-9c6b-b2b424ce571b.jpg',
        prompt:
          'Original character design with distinct personality and detailed features',
      },
    ],
  },
  {
    slug: 'menu-design',
    name: 'Restaurant Menu Design',
    header: 'Create Appetizing Menu Designs',
    seo_description:
      'Generate professional menu designs with AI. Perfect for restaurants, cafes, and food businesses needing attractive menu layouts.',
    description:
      'Design mouth-watering menus with our AI. Create professional restaurant menus that showcase your dishes beautifully.',
    search_query: 'menu dish photos',
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/083a7153-f50c-470c-bfb4-a45c27d576f0.png',
        prompt:
          'Elegant restaurant menu design with appetizing food photography and clean typography',
      },
    ],
  },
  {
    slug: 'podcast-cover',
    name: 'Podcast Cover',
    header: 'Create Professional Podcast Artwork',
    seo_description:
      'Generate stunning podcast cover art with AI. Perfect for podcasters and audio content creators needing professional show artwork.',
    description:
      'Design eye-catching podcast covers with our AI. Create professional artwork that helps your show stand out in directories.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/feb4905b-3b29-4c51-8305-2737cc13e55b.png',
        prompt:
          'Professional podcast cover art with bold typography and engaging visuals',
      },
    ],
  },
  {
    slug: 'instagram-post',
    name: 'Instagram Post',
    header: 'Create Stunning Instagram Posts',
    seo_description:
      'Generate captivating Instagram-worthy photos with AI. Perfect for content creators looking to enhance their feed with professional quality posts.',
    description:
      'Design engaging Instagram content with our AI. Create visually stunning photos that will make your feed stand out and grow your following.',
    search_query: 'Instagram photo',
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/fbc8977c-4060-45db-81c5-cc2fcaf18d10/003fa2aa-c67b-4533-afb1-4cb6df23acf2.png',
        prompt:
          'Stylish Instagram photo with perfect lighting and trendy aesthetic',
      },
    ],
  },
  {
    slug: 'luxury-lifestyle',
    name: 'Luxury Lifestyle',
    header: 'Create Sophisticated Luxury Content',
    seo_description:
      'Generate elegant luxury lifestyle photos with AI. Perfect for showcasing high-end fashion, luxury settings, and sophisticated lifestyle content.',
    description:
      'Design opulent lifestyle content with our AI. Create stunning visuals that capture the essence of luxury living.',
    skipTitle: false,
    isPhotoPack: false,
    isPhoto: true,
    search_query: 'Luxury Lifestyle portrait',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/luxury-lifestyle-hero.mp4',
        prompt:
          'Elegant luxury lifestyle photo in Dubai with high-end fashion and setting',
      },
    ],
  },
  {
    slug: 'selfie',
    name: 'Selfie',
    header: 'Create Perfect AI Selfies',
    seo_description:
      'Generate flawless selfies with AI. Perfect for social media, dating profiles, and personal branding with professional quality results.',
    description:
      'Design perfect selfies with our AI. Create stunning self-portraits that capture your best angles and expressions.',
    isPhoto: true,
    search_query: 'selfie photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/2b2490be-abc5-45a5-afaf-5c2a3eb077d5/f5622ab7-13b9-45f0-a533-3c114b715d7a.png',
        prompt:
          'Natural-looking selfie with perfect lighting and flattering angle',
      },
    ],
  },
  {
    slug: 'dating-profile',
    name: 'Dating Profile',
    header: 'Create Engaging Dating Profile Photos',
    seo_description:
      'Generate attractive dating profile photos with AI. Perfect for dating apps like Tinder, Bumble, and Hinge, helping you stand out and attract more matches.',
    description:
      'Design appealing dating profile photos with our AI. Create engaging images that showcase your personality and attract potential matches.',
    skipTitle: false,
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/bbd2a0e7-1533-4cf9-957d-13a3136cc11a/c5634164-33e3-4502-8b96-e96c05972bec.png',
        prompt:
          'Natural and engaging dating profile photo with authentic expression',
      },
    ],
  },
  {
    slug: 'glamour',
    name: 'Glamour',
    header: 'Create Stunning Glamour Photos',
    seo_description:
      'Generate professional glamour photos with AI. Perfect for capturing alluring poses and sophisticated beauty with striking lighting and style.',
    description:
      'Design captivating glamour photos with our AI. Create stunning images that highlight your natural beauty and confidence.',
    skipTitle: false,
    isPhoto: true,
    search_query: 'glamour photo',
    isPhotoPack: false,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/glamour-hero.mp4',
        prompt:
          'Elegant glamour portrait with dramatic lighting and sophisticated style',
      },
    ],
  },
  {
    slug: 'old-money',
    name: 'Old Money',
    header: 'Create Sophisticated Old Money Aesthetics',
    seo_description:
      'Generate elegant old money style photos with AI. Perfect for capturing timeless sophistication with preppy fashion and classic settings.',
    description:
      'Design refined old money aesthetic photos with our AI. Create images that embody timeless elegance and sophisticated charm.',
    skipTitle: false,
    search_query: 'country club portrait, person wearing Ralph Lauren',
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/41140694-6513-4753-87bf-1e6267201cf1.png',
        prompt:
          'Classic old money aesthetic at tennis club with preppy fashion',
      },
    ],
  },
  {
    slug: 'speaker',
    name: 'Speaker',
    header: 'Create Professional Speaking Photos',
    seo_description:
      'Generate compelling speaker photos with AI. Perfect for thought leaders and professionals needing powerful images of themselves presenting on stage.',
    description:
      'Design impactful speaking photos with our AI. Create professional images that showcase your authority and expertise.',
    skipTitle: false,
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7e0a8bd2-fd26-44ef-934c-53651d5ca77b.png',
        prompt:
          'Dynamic speaker photo on stage with confident pose and engaged audience',
      },
    ],
  },
  {
    slug: 'fitness',
    name: 'Fitness',
    header: 'Create Motivating Fitness Photos',
    seo_description:
      'Generate inspiring fitness photos with AI. Perfect for personal trainers, fitness enthusiasts, and anyone documenting their fitness journey.',
    description:
      'Design powerful fitness photos with our AI. Create motivating images that showcase your progress and dedication.',
    skipTitle: false,
    isPhoto: true,
    search_query: 'Fitness Photos',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/fitness-hero.mp4',
        prompt:
          'Dynamic fitness photo showing strength and dedication in professional gym setting',
      },
    ],
  },
  {
    slug: 'muscle',
    name: 'Muscle',
    header: 'Create Powerful Muscle Definition Photos',
    seo_description:
      'Generate impressive muscle definition photos with AI. Perfect for bodybuilders, fitness professionals, and anyone showcasing their physique development.',
    description:
      'Design striking muscle photos with our AI. Create detailed images that highlight muscular definition and physical achievements.',
    isPhoto: true,
    search_query: 'muscle photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0be1248a-23fb-4bf3-a9fb-03009219afd6.png',
        prompt:
          'Professional bodybuilder photo showing detailed muscle definition with dramatic lighting',
      },
    ],
  },
  {
    slug: 'mythical-creature',
    name: 'Mythical Creature',
    header: 'Create Fantastical Mythical Creature Images',
    seo_description:
      'Generate stunning mythical creature images with AI. Perfect for fantasy enthusiasts, game designers, and creative projects featuring dragons, unicorns, and other legendary beings.',
    description:
      'Design extraordinary mythical creature images with our AI. Create magical beings that bring fantasy worlds to life with stunning detail and imagination.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/0d175a3f-52ff-4764-ac75-a8e6ec2d087d/8a199049-71be-4951-ae17-984215d48fe4.png',
        prompt:
          'Majestic dragon with iridescent scales soaring through misty mountains at sunset',
      },
    ],
  },
  {
    slug: 'villain',
    name: 'Villain',
    header: 'Create Compelling Villain Characters',
    seo_description:
      'Generate menacing villain images with our AI. Perfect for storytellers, game developers, and creative projects featuring antagonists and evil characters.',
    description:
      'Design captivating villain characters with our AI. Create sinister antagonists with striking features that embody the perfect foil to any hero.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/villain-hero.mp4',
        prompt:
          'Menacing villain character with dark attire and dramatic lighting, sinister expression',
      },
    ],
  },
  {
    slug: 'ghibli',
    name: 'Ghibli',
    header: 'Create Enchanting Studio Ghibli Style Images',
    seo_description:
      'Generate beautiful Studio Ghibli inspired images with AI. Perfect for anime fans, illustrators, and creative projects featuring whimsical characters and magical landscapes.',
    description:
      'Design charming Studio Ghibli style artwork with our AI. Create images with the distinctive aesthetic of Hayao Miyazaki films, featuring dreamy landscapes and endearing characters.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/60065e87-732e-4e63-bf41-0645a09cb897/472d7ae2-acea-40f2-bec7-7f1768e791d3.png',
        prompt:
          'Whimsical countryside landscape with a small cottage, floating islands, and magical creatures in Studio Ghibli style',
      },
    ],
  },
  {
    slug: 'isometric-art',
    name: 'Isometric Art',
    header: 'Create Stunning Isometric Illustrations',
    seo_description:
      'Generate precise isometric artwork with our AI. Perfect for game assets, infographics, and architectural visualization with a modern 3D-like perspective.',
    description:
      'Design eye-catching isometric illustrations with our AI. Create detailed 3D-like visuals with perfect geometric precision for games, apps, and technical illustrations.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as the diorama coming to life (traffic, fountain,
        // chimney smoke) on a locked isometric camera,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/isometric-art-hero.mp4',
        prompt:
          'Colorful isometric cityscape with tiny buildings, vehicles, and people in a geometric 3D perspective',
      },
    ],
  },
  {
    slug: 'chalk-art',
    name: 'Chalk Art',
    header: 'Create Realistic Chalk Board Art',
    seo_description:
      'Generate authentic chalk artwork with our AI. Perfect for creating menu boards, educational content, and rustic designs with a hand-drawn feel.',
    description:
      'Design charming chalk art with our AI. Create illustrations that look hand-drawn on blackboard textures, complete with realistic chalk texture and depth.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/chalk-art-hero.mp4',
        prompt:
          'Hand-drawn style cafe menu on blackboard with chalk lettering, illustrations, and smudge effects',
      },
    ],
  },
  {
    slug: 'holographic',
    name: 'Holographic',
    header: 'Create Shimmering Holographic Art',
    seo_description:
      'Generate dazzling holographic artwork with our AI. Perfect for creating modern designs with rainbow iridescence and futuristic digital aesthetics.',
    description:
      'Design captivating holographic visuals with our AI. Create images with mesmerizing rainbow color shifts and reflective textures for a contemporary digital look.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/03161798-d57c-48ca-b8bf-1ca22575c0ef/fe2ef332-af3b-4ca4-9a42-bc5846aa7cc3.png',
        prompt:
          'Holographic abstract design with iridescent rainbow colors and reflective textures on dark background',
      },
    ],
  },
  {
    slug: 'art-nouveau',
    name: 'Art Nouveau',
    header: 'Create Elegant Art Nouveau Designs',
    seo_description:
      'Generate ornate Art Nouveau artwork with our AI. Perfect for creating elegant designs with the curved lines, natural forms, and decorative elements of this classic style.',
    description:
      'Design sophisticated Art Nouveau artwork with our AI. Create images featuring the distinctive flowing lines, organic forms, and decorative elegance of this influential artistic movement.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/03161798-d57c-48ca-b8bf-1ca22575c0ef/5dd81d32-982a-472b-8d68-85b8d96b78b9.png',
        prompt:
          'Ornate Art Nouveau illustration of woman with flowing hair surrounded by decorative floral elements and curved lines',
      },
    ],
  },
  {
    slug: 'collage-art',
    name: 'Collage Art',
    header: 'Create Mixed Media Collage Artwork',
    seo_description:
      'Generate vibrant mixed media collage artwork with our AI. Perfect for creating unique compositions that combine different elements, textures, and styles into cohesive artistic pieces.',
    description:
      'Design striking collage artwork with our AI. Create dynamic mixed media compositions that layer various elements together for visually rich and textured results.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/03161798-d57c-48ca-b8bf-1ca22575c0ef/d00f91e4-b026-43cb-9ffc-36038654e1bf.png',
        prompt:
          'Mixed media collage combining vintage photographs, colorful paper cutouts, painted elements, and typography in an artistic composition',
      },
    ],
  },
  {
    slug: 'steampunk',
    name: 'Steampunk',
    header: 'Create Victorian-Inspired Steampunk Art',
    seo_description:
      'Generate intricate steampunk artwork with our AI. Perfect for creating alternative history visuals with Victorian aesthetics, brass machinery, and retro-futuristic elements.',
    description:
      'Design imaginative steampunk artwork with our AI. Create images featuring vintage-futuristic technology, brass gears, and Victorian-era aesthetics.',
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/4f1eabdb-409e-41eb-bea8-d7b441e63d75/efff54ea-babe-49b5-8a10-feab72547eb2.png',
        prompt:
          'Detailed steampunk illustration of a brass and copper airship with gears, valves, and steam engines flying through cloudy Victorian-era skies',
      },
    ],
  },
  {
    slug: 'claymation',
    name: 'Claymation',
    header: 'Create Charming Claymation-Style Art',
    seo_description:
      'Generate delightful claymation-style artwork with our AI. Perfect for creating whimsical characters and scenes with the distinctive texture and charm of stop-motion clay animation.',
    description:
      'Design fun claymation-style images with our AI. Create characters and scenes with the unique textured look and playful feel of clay animation.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted, 960px wide.
        url: 'https://media.easy-peasy.ai/landing/image-styles/claymation-hero.mp4',
        prompt:
          'Whimsical claymation character with exaggerated features and visible texture, posed against a handcrafted miniature set',
      },
    ],
  },
  {
    slug: 'glitch-art',
    name: 'Glitch Art',
    header: 'Create Digital Glitch Effects',
    seo_description:
      'Generate striking glitch art with our AI. Perfect for creating contemporary digital designs with distorted pixels, data corruption aesthetics, and abstract electronic visuals.',
    description:
      'Design edgy glitch artwork with our AI. Create images with digital artifacts, distortion effects, and corrupted data aesthetics for a modern technological look.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/03161798-d57c-48ca-b8bf-1ca22575c0ef/53e23bc2-9b3b-4d9d-aa58-a2dbd75cf032.png',
        prompt:
          'Digital glitch portrait with pixelated distortion, RGB shifts, and data corruption effects on a modern technological background',
      },
    ],
  },

  {
    slug: 'gothic',
    name: 'Gothic',
    header: 'Create Dark Gothic Imagery',
    seo_description:
      'Generate haunting gothic artwork with our AI. Perfect for creating atmospheric designs with dark aesthetics, medieval elements, and the dramatic mood of gothic fiction and architecture.',
    description:
      'Design dramatic gothic imagery with our AI. Create images featuring ornate architecture, mysterious atmospheres, and the dark romantic aesthetic of gothic tradition.',
    isPhoto: true,
    search_query: 'Gothic photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/b758cfa4-20c6-41ad-af9a-14c7e1d5327f/daf97c08-5151-4725-834c-3f78a6314bfa.png',
        prompt:
          'Atmospheric gothic scene with towering cathedral spires, flying buttresses, stained glass, and misty moonlit surroundings',
      },
    ],
  },
  {
    slug: 'furniture',
    name: 'Furniture',
    header: 'Create Stunning Furniture Designs',
    seo_description:
      'Generate beautiful furniture designs with our AI. Perfect for creating modern, classic, or innovative furniture concepts with realistic details, textures, and materials.',
    description:
      'Design impressive furniture pieces with our AI. Create images of chairs, tables, sofas, and more with various styles, materials, and settings for interior design inspiration.',
    isPhoto: true,
    search_query: 'modern Furniture photos',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/44025d66-5ac5-4a57-bd3e-911b8eaff09b.png',
        prompt:
          'Elegant mid-century modern armchair with wooden frame, plush upholstery, and clean lines, positioned in a minimalist living room with natural lighting',
      },
    ],
  },
  {
    slug: 'uniform',
    name: 'Uniform',
    header: 'Create Professional Uniform Designs',
    seo_description:
      'Generate professional uniform designs with our AI. Perfect for creating corporate, service, medical, military, or hospitality uniforms with realistic details, fabrics, and styling.',
    description:
      'Design impressive uniform concepts with our AI. Create images of professional attire for various industries with accurate details, functional elements, and contemporary styling.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/uniform-hero.mp4',
        prompt:
          'Professional modern corporate uniform with tailored blazer, crisp shirt, and subtle branding elements, displayed on a model in a clean office environment',
      },
    ],
  },
  {
    slug: 'pet-portrait',
    name: 'Pet Portrait',
    header: 'Create Charming Pet Portraits',
    seo_description:
      'Generate beautiful pet portraits with our AI. Perfect for creating memorable images of dogs, cats, and other beloved animals with realistic details, personality, and charm.',
    description:
      'Design stunning pet portraits with our AI. Create images that capture the unique personality and character of pets in various artistic styles, settings, and moods.',
    isPhoto: true,
    search_query: 'Pet Portrait photos',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3598b7f3-90df-4002-9c60-8282b12bbe79.png',
        prompt:
          'Detailed portrait of a golden retriever with expressive eyes, soft fur texture, and gentle expression, set against a neutral background with natural lighting',
      },
    ],
  },
  // nail art
  {
    slug: 'nail-art',
    name: 'Nail Art',
    header: 'Create Beautiful Nail Art Designs',
    seo_description:
      'Generate stunning nail art designs with our AI. Perfect for creating unique and creative nail designs with realistic details, textures, and colors.',
    description:
      'Design eye-catching nail art with our AI. Create images that showcase various nail art styles, colors, and patterns for a fashionable and artistic look.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/nail-art-hero.mp4',
        prompt:
          'Beautiful nail art design with intricate patterns, vibrant colors, and shiny gloss, set against a neutral background with natural lighting',
      },
    ],
  },
  {
    slug: 'horror-art',
    name: 'Horror Art',
    header: 'Create Spine-Chilling Horror Art',
    seo_description:
      'Generate terrifying horror art with our AI. Ideal for artists, writers, game developers, and horror fans looking to create disturbing visuals and nightmarish scenes.',
    description:
      'Dive into the macabre with our AI horror art generator. Craft unsettling images, from grotesque monsters to haunted landscapes, and bring your most terrifying visions to life.',
    skipTitle: true,
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/horror-art-hero.mp4',
        prompt:
          'A shadowy creature with glowing red eyes lurking in a dark, misty forest, digital painting, horror art style',
      },
    ],
  },
  {
    slug: 'pop-art',
    name: 'Pop Art',
    header: 'Create Iconic Pop Art',
    seo_description:
      'Generate vibrant and iconic pop art with our AI. Perfect for artists, designers, and enthusiasts looking to create bold, colorful artwork in classic pop art styles.',
    description:
      'Transform your images or ideas into striking pop art with our AI. Experiment with bold colors, graphic patterns, and iconic imagery reminiscent of Warhol and Lichtenstein.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/d09c5306-6f1e-4d84-945d-acef9fbec1b3.webp', // Placeholder URL
        prompt:
          'Pop art style portrait of a woman with bright yellow hair and red lips, Ben-Day dots, bold outlines, vibrant colors, comic book aesthetic.',
      },
    ],
  },
  {
    slug: 'typography-art',
    name: 'Typography Art',
    header: 'Create Stunning Typography Art',
    seo_description:
      'Generate captivating typography art with our AI. Perfect for designers, marketers, and artists looking to create visually striking text-based designs and typographic posters.',
    description:
      'Design unique and expressive typography art with our AI. Transform text into compelling visual compositions using various fonts, layouts, artistic effects, and creative arrangements.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/typography-art-hero.mp4',
        prompt:
          'Artistic typography design of the word "Explore" using bold, colorful 3D letters with abstract shapes and patterns integrated into the text, dynamic composition, vibrant background.',
      },
    ],
  },
  {
    slug: 'action-figure',
    name: 'Action Figure',
    header: 'Create Custom Action Figures',
    seo_description:
      'Generate stylized action figure characters with our AI. Perfect for toy design concepts, collectors, and stylized character renders.',
    description:
      'Design toy-style action figure characters with our AI. Create glossy plastic materials, heroic poses, studio lighting, and collectible packaging concepts.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/92bb1409-aeda-497a-80d6-872be8cb76b6.png',
        prompt:
          'Best HR assistant action figure with a friendly smile, wearing a suit and tie, standing in a modern office environment',
      },
    ],
  },
  {
    slug: 'fight',
    name: 'Fight',
    header: 'Create Epic Fight Scenes',
    seo_description:
      'Generate dynamic fight scenes with our AI. Perfect for action shots, martial arts, superheroes, and cinematic combat imagery.',
    description:
      'Design intense action sequences with our AI. Create dynamic poses, motion blur, dramatic lighting, and cinematic composition for epic battles.',
    isPhoto: true,
    search_query: 'Fight photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/fight-hero.mp4',
        prompt:
          'Two martial artists locked mid-air in a dramatic kick exchange in a rain-soaked alley, cinematic lighting, motion blur, high contrast',
      },
    ],
  },
  {
    slug: 'wedding-photo',
    name: 'Wedding Photo',
    header: 'Create Your Own Wedding Photo',
    seo_description:
      'Generate beautiful wedding photo designs with our AI. Perfect for couples, photographers, and designers creating romantic wedding imagery.',
    description:
      'Design romantic and timeless wedding photos with our AI. Capture elegant poses, natural lighting, and classic wedding aesthetics.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/wedding-photo-hero.mp4',
        prompt:
          'Elegant wedding photo of a bride and groom during golden hour, natural light, shallow depth of field, candid joyful moment, professional photography',
      },
    ],
  },
  {
    slug: 'age-progression',
    name: 'Age Progression',
    header: 'Create Your Own Age Progression',
    seo_description:
      'Generate realistic age progression portraits with our AI. Perfect for visualizing how a person might look across different ages while keeping consistent features.',
    description:
      'Design photorealistic age progression portraits with our AI. See the same person at multiple stages of life with consistent facial features, lighting, and camera style.',
    isPhoto: true,
    search_query: 'Age Progression photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/324a89fb-b995-4ef0-a283-bdc03d5cbf18.png', // Placeholder URL, ensure this image exists or replace it
        prompt:
          'Age progression portrait of the same person at ages 10, 25, 45, and 70, consistent facial features, photorealistic, studio lighting, neutral background',
      },
    ],
  },
  {
    slug: 'tarot-card',
    name: 'Tarot Card',
    header: 'Create Your Own Tarot Cards',
    seo_description:
      'Generate tarot card designs with our AI. Perfect for artists, designers, and readers seeking Rider–Waite-inspired or custom deck artwork.',
    description:
      'Design ornate tarot cards with symbolic illustrations, vintage textures, and decorative borders. Create major and minor arcana with consistent deck aesthetics.',
    isPhoto: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/tarot-card-hero.mp4',
        prompt:
          'The Fool tarot card illustration, Rider–Waite style, ornate gold border, flat vector, muted vintage palette, subtle print texture, centered composition',
      },
    ],
  },
  {
    slug: 'magazine-cover',
    name: 'Magazine Cover',
    header: 'Create Your Own Magazine Cover',
    seo_description:
      'Generate professional magazine cover designs with our AI. Perfect for editors, marketers, and creators needing striking covers for fashion, tech, lifestyle, or news.',
    description:
      'Design eye-catching magazine covers with bold mastheads, coverlines, barcode placement, and editorial layout. Create fashion, lifestyle, or tech covers with studio lighting and strong typography.',
    isPhoto: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/59c840d7-7301-4bea-8102-911990b356cf.png', // Placeholder URL, ensure this image exists or replace it
        prompt:
          'High-end fashion magazine cover, confident model portrait, bold masthead at top, multiple coverlines on left and right, barcode bottom right, clean editorial layout, studio lighting',
      },
    ],
  },
  {
    slug: 'dragon',
    name: 'Dragon',
    header: 'Create Epic Dragon Art',
    seo_description:
      'Generate powerful dragon images with our AI. Perfect for fantasy art, game concepts, and illustrations featuring legendary creatures.',
    description:
      'Design legendary dragons with intricate scales, dramatic wings, elemental breath, and cinematic lighting. Create majestic scenes in fantasy settings.',
    skipTitle: true,
    images: [
      {
        url: 'https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1fc33db0-b71a-4c33-8773-15ace990a66b.png', // Placeholder URL, ensure this image exists or replace it
        prompt:
          'Majestic dragon breathing fire atop a mountain peak at dusk, ultra-detailed scales, glowing embers, cinematic lighting, fantasy art',
      },
    ],
  },
  {
    slug: 'political-cartoon',
    name: 'Political Cartoon',
    header: 'Create Political Cartoons',
    seo_description:
      'Generate satirical political cartoons with our AI. Perfect for editorial illustrations, op-eds, and social commentary.',
    description:
      'Design editorial-style political cartoons with bold ink lines, caricature exaggeration, speech bubbles, and newspaper print textures.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/political-cartoon-hero.mp4',
        prompt:
          'Satirical political cartoon of a balanced debate scene at podiums with symbolic scales of justice, bold ink, cross-hatching, speech bubbles, newspaper print texture, monochrome with a red accent',
      },
    ],
  },
  {
    slug: 'therapist-headshots',
    name: 'Therapist Headshots',
    header: 'Professional Therapist Headshots',
    seo_description:
      'Generate warm and professional therapist headshots with our AI. Perfect for mental health professionals, counselors, and practitioners building trust with clients.',
    description:
      'Create approachable and professional therapist headshots that convey empathy and expertise. Ideal for psychology practices, counseling centers, and mental health professionals.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e442901c-9cda-4ac7-a66c-979cf859d2d2.png',
        prompt:
          'Professional therapist headshot with warm, approachable expression',
      },
    ],
  },
  {
    slug: 'lawyer-headshots',
    name: 'Lawyer Headshots',
    header: 'Professional Lawyer Headshots',
    seo_description:
      'Generate confident and authoritative lawyer headshots with our AI. Perfect for law firms, legal consultants, and attorneys building their professional image.',
    description:
      'Create polished and professional lawyer headshots that convey trust and expertise. Ideal for law firm websites, legal directories, and professional networking.',
    skipTitle: true,
    isPhotoPack: false,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9d758af9-9726-4f02-8a68-06965e117499.png',
        prompt:
          'Professional lawyer headshot in business attire with confident expression',
      },
    ],
  },
  {
    slug: 'comedian-headshots',
    name: 'Comedian Headshots',
    header: 'Expressive Comedian Headshots',
    seo_description:
      'Generate charismatic and engaging comedian headshots with our AI. Perfect for stand-up comedians, entertainers, and performers showcasing their personality.',
    description:
      'Create vibrant and expressive comedian headshots that capture your unique personality and stage presence. Ideal for comedy clubs, talent agencies, and entertainment portfolios.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c9f947c1-9c67-412c-b904-5c8e58caabf2.png',
        prompt: 'Comedian headshot with engaging smile and expressive features',
      },
    ],
  },
  {
    slug: 'teacher-headshots',
    name: 'Teacher Headshots',
    header: 'Professional Teacher Headshots',
    seo_description:
      'Generate friendly and professional teacher headshots with our AI. Perfect for educators, professors, and academic professionals building their professional presence.',
    description:
      'Create warm and approachable teacher headshots that convey knowledge and dedication. Ideal for school websites, educational platforms, and academic portfolios.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9f0110b6-a21c-4a86-869c-26fb9977c60d.png',
        prompt:
          'Professional teacher headshot with friendly, knowledgeable appearance',
      },
    ],
  },
  {
    slug: 'life-coach-headshots',
    name: 'Life Coach Headshots',
    header: 'Inspiring Life Coach Headshots',
    seo_description:
      'Generate motivating and professional life coach headshots with our AI. Perfect for coaches, mentors, and personal development professionals.',
    description:
      'Create inspiring and trustworthy life coach headshots that convey positivity and expertise. Ideal for coaching websites, social media profiles, and professional marketing materials.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/05dadb3b-8a5f-4145-8b57-2310eec71b7b.png',
        prompt: 'Life coach headshot with inspiring, confident expression',
      },
    ],
  },
  {
    slug: 'doctor-headshots',
    name: 'Doctor Headshots',
    header: 'Professional Doctor Headshots',
    seo_description:
      'Generate trustworthy and professional doctor headshots with our AI. Perfect for medical professionals, healthcare providers, and clinical practitioners.',
    description:
      'Create professional and reassuring doctor headshots that convey medical expertise and compassion. Ideal for hospital directories, medical practice websites, and healthcare platforms.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/doctor-headshots-hero.mp4',
        prompt:
          'Professional doctor headshot in white coat with trustworthy expression',
      },
    ],
  },
  {
    slug: 'real-estate-agent-headshots',
    name: 'Real Estate Agent Headshots',
    header: 'Professional Real Estate Agent Headshots',
    seo_description:
      'Generate confident and approachable real estate agent headshots with our AI. Perfect for realtors, brokers, and property professionals building their brand.',
    description:
      'Create polished and professional real estate agent headshots that convey trust and expertise. Ideal for property listings, business cards, and real estate marketing materials.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c441a330-dbe2-4b26-ba7c-6e15fbb92f33.png',
        prompt:
          'Real estate agent headshot with professional, approachable demeanor',
      },
    ],
  },
  {
    slug: 'model-headshots',
    name: 'Model Headshots',
    header: 'Stunning Model Headshots',
    seo_description:
      'Generate captivating and professional model headshots with our AI. Perfect for aspiring models, actors, and talent portfolios.',
    description:
      'Create striking and versatile model headshots that showcase your features and potential. Ideal for modeling agencies, casting calls, and professional portfolios.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/092963ee-2669-481b-af0e-4f1864010553.png',
        prompt:
          'Professional model headshot with striking features and natural lighting',
      },
    ],
  },
  {
    slug: 'corporate-team-headshots',
    name: 'Corporate Headshots For Your Team',
    header: 'Unified Corporate Team Headshots',
    seo_description:
      'Generate consistent and professional corporate team headshots with our AI. Perfect for company websites, annual reports, and team presentations.',
    description:
      'Create cohesive and professional corporate team headshots that maintain brand consistency. Ideal for company directories, team pages, and corporate communications.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1a506c3b-812e-4f1d-90f2-1ad7e31550ae.png',
        prompt:
          'Professional corporate headshot with consistent lighting and background',
      },
    ],
  },
  {
    slug: 'author-headshots',
    name: 'Author Headshots',
    header: 'Distinguished Author Headshots',
    seo_description:
      'Generate thoughtful and professional author headshots with our AI. Perfect for writers, journalists, and literary professionals building their author platform.',
    description:
      'Create sophisticated and engaging author headshots that convey creativity and expertise. Ideal for book covers, author websites, and literary promotional materials.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/62982fe2-93fa-425a-8ecf-02db220f353e.png',
        prompt: 'Author headshot with thoughtful, intellectual expression',
      },
    ],
  },
  {
    slug: 'dating-headshots',
    name: 'Dating Headshots',
    header: 'Attractive Dating Profile Headshots',
    seo_description:
      'Generate appealing and authentic dating headshots with our AI. Perfect for dating profiles, social media, and personal branding.',
    description:
      'Create attractive and genuine dating headshots that showcase your personality. Ideal for dating apps, social media profiles, and personal networking.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/bbe5d080-19c8-4baa-98df-3fc2ca8ed6d1.png',
        prompt: 'Attractive dating headshot with genuine, approachable smile',
      },
    ],
  },
  {
    slug: 'ceo-headshots',
    name: 'CEO Headshots',
    header: 'Executive CEO Headshots',
    seo_description:
      'Generate authoritative and professional CEO headshots with our AI. Perfect for executives, business leaders, and corporate leadership.',
    description:
      'Create powerful and professional CEO headshots that convey leadership and vision. Ideal for annual reports, press releases, and executive communications.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2ed0b67c-b4eb-46fc-81c3-60616fc057b8.png',
        prompt: 'CEO headshot with confident, authoritative presence',
      },
    ],
  },
  {
    slug: 'actor-headshots',
    name: 'Actor Headshots',
    header: 'Professional Actor Headshots',
    seo_description:
      'Generate versatile and expressive actor headshots with our AI. Perfect for casting calls, talent agencies, and performance portfolios.',
    description:
      'Create dynamic and professional actor headshots that showcase your range and personality. Ideal for auditions, casting directories, and entertainment industry profiles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/10ab10e2-4782-4683-b054-e98e25c9a903.png',
        prompt:
          'Actor headshot with expressive features and professional lighting',
      },
    ],
  },
  {
    slug: 'professional-headshots',
    name: 'Professional Headshots',
    header: 'Universal Professional Headshots',
    seo_description:
      'Generate polished and versatile professional headshots with our AI. Perfect for any industry professional looking to enhance their professional image.',
    description:
      'Create timeless and professional headshots suitable for any industry or profession. Ideal for LinkedIn profiles, company websites, and professional networking.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/fb639bb3-9b3b-421e-a672-db99164b1a8b.png',
        prompt: 'Professional headshot with polished, confident appearance',
      },
    ],
  },
  {
    slug: 'linkedin-headshots',
    name: 'LinkedIn Headshots',
    header: 'Professional LinkedIn Headshots',
    seo_description:
      'Generate optimized LinkedIn headshots with our AI. Perfect for professionals looking to stand out on LinkedIn with a polished, approachable profile photo.',
    description:
      'Create professional LinkedIn headshots that make a strong first impression. Ideal for job seekers, networkers, and professionals building their LinkedIn presence with industry-appropriate styling.',
    skipTitle: true,
    isPhotoPack: false,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/92a2aeb7-73eb-4012-a7ca-bd97e0095f19.png',
        prompt:
          'Professional LinkedIn headshot with confident smile and business attire',
      },
    ],
  },
  {
    slug: 'dancer-headshots',
    name: 'Dancer Headshots',
    header: 'Dynamic Dancer Headshots',
    seo_description:
      'Generate expressive dancer headshots with our AI. Perfect for professional dancers, choreographers, and performers showcasing their artistry and stage presence.',
    description:
      'Create dynamic and expressive dancer headshots that capture movement and artistic expression. Ideal for auditions, dance company profiles, and performance portfolios.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a053064e-5298-45b0-98db-1824179d544e.png',
        prompt:
          'Professional dancer headshot with graceful expression and dynamic pose',
      },
    ],
  },
  {
    slug: 'outdoor-headshots',
    name: 'Outdoor Headshots',
    header: 'Natural Outdoor Headshots',
    seo_description:
      'Generate beautiful outdoor headshots with our AI. Perfect for creating natural, lifestyle portraits with environmental backgrounds and natural lighting.',
    description:
      'Create stunning outdoor headshots with natural lighting and environmental settings. Ideal for lifestyle photography, casual professional portraits, and authentic personal branding.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/42d94cc2-37f9-4a03-b466-81a1d5d55852.png',
        prompt:
          'Outdoor headshot with natural lighting and environmental background',
      },
    ],
  },
  {
    slug: 'personal-trainer-headshots',
    name: 'Personal Trainer Headshots',
    header: 'Fitness Professional Headshots',
    seo_description:
      'Generate energetic personal trainer headshots with our AI. Perfect for fitness professionals, gym instructors, and wellness coaches showcasing their expertise.',
    description:
      'Create powerful and motivating personal trainer headshots that convey fitness expertise and energy. Ideal for gym websites, fitness apps, and professional training portfolios.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/5fa24c5f-d142-4d55-aa00-36dbe87b0291.png',
        prompt:
          'Personal trainer headshot with athletic confidence and professional fitness attire',
      },
    ],
  },
  {
    slug: 'chef-headshots',
    name: 'Chef Headshots',
    header: 'Professional Chef Headshots',
    seo_description:
      'Generate culinary professional headshots with our AI. Perfect for chefs, restaurateurs, and culinary artists showcasing their expertise and personality.',
    description:
      'Create appetizing chef headshots that convey culinary expertise and passion. Ideal for restaurant websites, culinary profiles, and food industry marketing.',
    skipTitle: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/chef-headshots-hero.mp4',
        prompt:
          'Professional chef headshot in chef whites with confident culinary expertise',
      },
    ],
  },
  {
    slug: 'nurse-headshots',
    name: 'Nurse Headshots',
    header: 'Compassionate Nurse Headshots',
    seo_description:
      'Generate caring nurse headshots with our AI. Perfect for nursing professionals, healthcare providers, and medical staff building trust with patients.',
    description:
      'Create warm and professional nurse headshots that convey compassion and medical expertise. Ideal for hospital directories, healthcare websites, and medical professional profiles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9c5bfd93-b51e-400f-bed1-e1e16f6987da.png',
        prompt:
          'Professional nurse headshot with caring expression in medical scrubs',
      },
    ],
  },
  {
    slug: 'hair-stylist-headshots',
    name: 'Hair Stylist Headshots',
    header: 'Creative Hair Stylist Headshots',
    seo_description:
      'Generate stylish hair stylist headshots with our AI. Perfect for salon professionals, beauty experts, and creative stylists showcasing their artistic flair.',
    description:
      'Create trendy and professional hair stylist headshots that showcase creativity and style expertise. Ideal for salon websites, beauty portfolios, and social media profiles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b7071553-7837-4ee3-ac41-8e767e870749.png',
        prompt:
          'Hair stylist headshot with creative style and professional salon appearance',
      },
    ],
  },
  {
    slug: 'musician-headshots',
    name: 'Musician Headshots',
    header: 'Artistic Musician Headshots',
    seo_description:
      'Generate expressive musician headshots with our AI. Perfect for artists, bands, and music professionals creating compelling promotional materials.',
    description:
      'Create captivating musician headshots that convey artistic expression and musical identity. Ideal for album covers, press kits, and music industry profiles.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3f51ac4b-58c5-40e4-8a4c-284094a1edd8.png',
        prompt:
          'Musician headshot with artistic expression and creative lighting',
      },
    ],
  },
  {
    slug: 'interior-designer-headshots',
    name: 'Interior Designer Headshots',
    header: 'Sophisticated Interior Designer Headshots',
    seo_description:
      'Generate elegant interior designer headshots with our AI. Perfect for design professionals showcasing their aesthetic sense and creative expertise.',
    description:
      'Create sophisticated interior designer headshots that reflect style and design expertise. Ideal for design portfolios, professional websites, and industry directories.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a3f85d09-37a2-4433-b3db-bf2e4495a73f.png',
        prompt:
          'Interior designer headshot with sophisticated style in elegant design setting',
      },
    ],
  },
  {
    slug: 'insurance-agent-headshots',
    name: 'Insurance Agent Headshots',
    header: 'Trustworthy Insurance Agent Headshots',
    seo_description:
      'Generate professional insurance agent headshots with our AI. Perfect for insurance professionals, brokers, and financial advisors building client trust.',
    description:
      'Create trustworthy and professional insurance agent headshots that convey reliability and expertise. Ideal for insurance websites, business cards, and client communications.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1cb8b1ed-a8e7-4b7a-9656-4250dee1e00d.png',
        prompt:
          'Insurance agent headshot with trustworthy expression and professional business attire',
      },
    ],
  },
  {
    slug: 'dentist-headshots',
    name: 'Dentist Headshots',
    header: 'Professional Dentist Headshots',
    seo_description:
      'Generate friendly dentist headshots with our AI. Perfect for dental professionals, orthodontists, and oral health specialists building patient trust.',
    description:
      'Create warm and professional dentist headshots that convey expertise and patient care. Ideal for dental practice websites, medical directories, and patient communications.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/fd1f0b1b-9811-4f12-a8cb-d625802116b2.png',
        prompt:
          'Dentist headshot with friendly smile in white coat and professional dental setting',
      },
    ],
  },
  {
    slug: 'financial-advisor-headshots',
    name: 'Financial Advisor Headshots',
    header: 'Expert Financial Advisor Headshots',
    seo_description:
      'Generate authoritative financial advisor headshots with our AI. Perfect for wealth managers, investment advisors, and financial planners establishing credibility.',
    description:
      'Create professional and trustworthy financial advisor headshots that convey expertise and fiscal responsibility. Ideal for financial firms, advisory websites, and client presentations.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2c11101b-c297-42e1-9083-b8b58b2f24fe.png',
        prompt:
          'Financial advisor headshot with confident expression in professional business attire',
      },
    ],
  },
  // feet
  {
    slug: 'feet',
    name: 'Feet',
    header: 'Create Beautiful Feet',
    seo_description:
      'Generate beautiful feet with our AI. Perfect for creating stunning feet images with realistic details and textures.',
    skipTitle: true,
    isHidden: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/feet-hero.mp4',
        prompt:
          'Artistic foot photography with aesthetic composition and natural beauty, detailed study of human anatomy with soft lighting and elegant presentation, professional beauty photography showcasing form and structure, tasteful artistic representation perfect for medical or artistic reference',
      },
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b2914c55-bea4-4c0f-99a4-554194bce855.png',
        prompt:
          'Artistic foot photography with aesthetic composition and natural beauty, detailed study of human anatomy with soft lighting and elegant presentation, professional beauty photography showcasing form and structure, tasteful artistic representation perfect for medical or artistic reference',
      },
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e8489edf-1e4a-4a51-95f0-fdd76b7cf40e.png',
        prompt:
          'Artistic foot photography with aesthetic composition and natural beauty, detailed study of human anatomy with soft lighting and elegant presentation, professional beauty photography showcasing form and structure, tasteful artistic representation perfect for medical or artistic reference',
      },
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/11e44f64-9d2a-4b32-b4e0-9645011b136f.png',
        prompt:
          'Artistic foot photography with aesthetic composition and natural beauty, detailed study of human anatomy with soft lighting and elegant presentation, professional beauty photography showcasing form and structure, tasteful artistic representation perfect for medical or artistic reference',
      },
    ],
  },
  {
    slug: 'infographic',
    name: 'Infographic',
    header: 'Visualize Your Data',
    seo_description:
      'Create informative and visually appealing infographics with our AI. Perfect for presenting data, explaining concepts, and telling visual stories.',
    description:
      'Transform complex information into clear and engaging infographics with our AI. Create professional data visualizations that communicate your message effectively.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3864b3ec-853d-41b1-9613-b27428e84e07.png',
        prompt:
          'Modern infographic design with clean data visualization, professional charts and graphs, iconographic elements and visual hierarchy, bold typography and color-coded sections, organized information layout with clear flow and engaging visual storytelling',
      },
    ],
  },
  {
    slug: 'lingerie',
    name: 'Lingerie',
    header: 'Elegant Intimate Apparel',
    seo_description:
      'Generate sophisticated lingerie designs with our AI. Perfect for fashion design, e-commerce, and creative projects.',
    description:
      'Create elegant and tasteful lingerie designs with our AI. Generate professional-quality intimate apparel images for fashion and design purposes.',
    skipTitle: true,
    isHidden: true,
    images: [
      {
        // Animated hero: editorial still animated with Seedance 2.0 Mini Image
        // (720p, 4s, 1:1), muted and re-encoded to 720x720 for page weight.
        url: 'https://media.easy-peasy.ai/landing/image-styles/lingerie.mp4',
        prompt:
          'Elegant lingerie design with sophisticated details, professional fashion photography lighting, tasteful composition with soft fabric textures, high-end intimate apparel styling with refined aesthetic and luxury presentation',
      },
    ],
  },
  // {
  //   slug: 'boudoir',
  //   name: 'Boudoir',
  //   header: 'Intimate Artistic Photography',
  //   seo_description:
  //     'Create tasteful boudoir photography with our AI. Perfect for artistic portraits, professional photography, and elegant compositions.',
  //   description:
  //     'Generate sophisticated boudoir-style photography with our AI. Create artistic and tasteful intimate portraits with professional lighting and elegant compositions.',
  //   skipTitle: true,
  //   isHidden: true,
  //   images: [
  //     {
  //       url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/eb4e434a-d619-4f0c-a7d4-116e093d21fd.png',
  //       prompt:
  //         'Elegant boudoir photography with soft romantic lighting, artistic composition with tasteful intimate styling, professional portrait quality with sophisticated mood, luxurious setting with refined aesthetic and subtle sensuality',
  //     },
  //   ],
  // },
  {
    slug: 'maternity',
    name: 'Maternity',
    header: 'Beautiful Pregnancy Photography',
    seo_description:
      'Create stunning maternity photography with our AI. Perfect for celebrating pregnancy, professional maternity shoots, and artistic portraits.',
    description:
      'Capture the beauty of pregnancy with our AI. Generate professional maternity photography with elegant compositions and soft, flattering lighting.',
    skipTitle: false,
    isPhoto: true,
    isHidden: true,
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/maternity-hero.mp4',
        prompt:
          'Professional maternity photography with soft natural lighting, elegant composition celebrating pregnancy, tender and intimate portrait style, beautiful expectant mother with flowing fabrics and gentle poses, warm and peaceful atmosphere',
      },
    ],
  },
  {
    slug: 'poster',
    name: 'Poster',
    header: 'Eye-Catching Poster Designs',
    seo_description:
      'Design striking posters with our AI. Perfect for events, marketing, movies, and promotional materials with bold visual impact.',
    description:
      'Create attention-grabbing posters with our AI. Generate professional designs for events, advertising, entertainment, and more with bold typography and compelling visuals.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/af8e0531-1f50-4b5c-bcac-ec5e36529733/c5e86cf0-255b-43bf-8f3a-887daa6a6c06.png',
        prompt:
          'Professional poster design with bold typography and striking visual hierarchy, eye-catching color scheme with strong composition, modern graphic design with balanced layout, impactful imagery and clear message communication',
      },
    ],
  },
  // {
  //   slug: 'brochure',
  //   name: 'Brochure',
  //   header: 'Professional Brochure Layouts',
  //   seo_description:
  //     'Create polished brochure designs with our AI. Perfect for business marketing, product catalogs, and informational materials.',
  //   description:
  //     'Design professional brochures with our AI. Generate elegant layouts for business presentations, product showcases, and marketing materials with clean, organized compositions.',
  //   skipTitle: true,
  //   images: [
  //     {
  //       url: 'https://media.easy-peasy.ai/brochure/sample.png',
  //       prompt:
  //         'Professional brochure design with clean multi-panel layout, organized information hierarchy with balanced text and images, corporate styling with modern aesthetic, professional photography and graphics integration, elegant color palette',
  //     },
  //   ],
  // },
  {
    slug: 'invitation',
    name: 'Invitation',
    header: 'Elegant Invitation Designs',
    seo_description:
      'Design beautiful invitations with our AI. Perfect for weddings, parties, events, and special occasions with personalized style.',
    description:
      'Create stunning invitations with our AI. Generate elegant designs for weddings, celebrations, and events with beautiful typography and decorative elements.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1597b05e-766c-4c5d-b9d7-776099a05e76.png',
        prompt:
          'invitation to birthday party, transformers theme, Blu Coral Condo, 22 Arpil. 11:00-15:00',
      },
    ],
  },
  {
    slug: 'flyer',
    name: 'Flyer',
    header: 'Impactful Flyer Designs',
    seo_description:
      'Create compelling flyer designs with our AI. Perfect for promotions, announcements, and marketing campaigns with bold visuals.',
    description:
      'Generate attention-grabbing flyers with our AI. Create effective promotional materials with bold graphics, clear messaging, and professional layouts.',
    skipTitle: true,
    search_query: 'flyer design',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7deed4cd-f48b-4af6-a27d-5fec1ab4bbe3.png',
        prompt:
          'Dynamic flyer design with bold headline and clear call-to-action, vibrant colors with strong visual impact, organized information layout with hierarchy, eye-catching graphics and modern design elements, professional marketing aesthetic',
      },
    ],
  },
  // {
  //   slug: 'timeline',
  //   name: 'Timeline',
  //   header: 'Visual Timeline Graphics',
  //   seo_description:
  //     'Design clear timeline graphics with our AI. Perfect for project planning, historical events, roadmaps, and process visualization.',
  //   description:
  //     'Create informative timeline graphics with our AI. Generate professional visual representations of chronological information, project milestones, and historical sequences.',
  //   skipTitle: true,
  //   images: [
  //     {
  //       url: 'https://media.easy-peasy.ai/timeline/sample.png',
  //       prompt:
  //         'Professional timeline graphic with clear chronological flow, organized milestones with visual markers, clean design with intuitive navigation, color-coded events and informative labels, modern infographic style with clear readability',
  //     },
  //   ],
  // },
  {
    slug: 'moodboard',
    name: 'Moodboard',
    header: 'Creative Moodboard Collages',
    seo_description:
      'Create inspiring moodboards with our AI. Perfect for design projects, brand identity, creative direction, and visual inspiration.',
    description:
      'Generate artistic moodboards with our AI. Create visual collections that capture aesthetics, themes, and creative concepts for design and inspiration.',
    skipTitle: true,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/63755fc1-7ea2-4399-98b5-33e9ebeec5f7.png',
        prompt:
          'Creative moodboard collage with curated images and textures, cohesive color palette and visual theme, artistic arrangement with balanced composition, mixed media elements and typography, inspirational aesthetic with harmonious flow',
      },
    ],
  },
  // instagram photos
  {
    slug: 'instagram-photos',
    name: 'Instagram Photos',
    header: 'Create Stunning Instagram Photos',
    seo_description:
      'Generate stunning Instagram photos with our AI. Perfect for content creators looking to enhance their feed with professional quality photos.',
    description:
      'Create stunning Instagram photos with our AI. Generate professional quality photos that will make your feed stand out and grow your following.',
    skipTitle: true,
    isPhotoPack: false,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/237a57ab-b706-4f2e-88da-caa80cd57668.png',
        prompt:
          'Instagram photo of a person wearing a creative costume with makeup, decorated house with carved pumpkins and cobwebs, posing with jack-o-lantern, playful spooky expression, orange and purple party lighting, natural lighting',
      },
    ],
  },
  // Halloween
  {
    slug: 'halloween-photos',
    name: 'Halloween Photos',
    header: 'Create Stunning Halloween Photos',
    seo_description:
      'Generate stunning Halloween photos with our AI. Perfect for content creators looking to enhance their feed with professional quality photos.',
    description:
      'Create stunning Halloween photos with our AI. Generate professional quality photos that will make your feed stand out and grow your following.',
    skipTitle: true,
    isPhotoPack: false,
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/97d23ae3-25b0-45c3-8ae7-c83b1aad92b3.png',
        prompt:
          'halloween party photo, person wearing creative costume with makeup, decorated house with carved pumpkins and cobwebs, posing with jack-o-lantern, playful spooky expression, orange and purple party lighting',
      },
    ],
  },
  // Fitness Influencer Photos
  {
    slug: 'fitness-influencer',
    name: 'Fitness Influencer',
    header: 'Create Stunning Fitness Influencer Photos',
    seo_description:
      'Generate stunning fitness influencer photos with our AI. Perfect for content creators looking to enhance their feed with professional quality photos.',
    description:
      'Create stunning fitness influencer photos with our AI. Generate professional quality photos that will make your feed stand out and grow your following.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'sports influencer woman',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/d856248e-1c39-4897-9150-1f8c45ccc4a3.png',
        prompt:
          'gym workout shot, person wearing fitted tank top and athletic shorts, modern gym with equipment, mid-bicep curl with dumbbells, focused intense expression, dramatic gym lighting',
      },
    ],
  },
  // polaroid photos
  {
    slug: 'polaroid-photos',
    name: 'Polaroid Photos',
    header: 'Create Stunning Polaroid Photos',
    seo_description:
      'Generate stunning polaroid photos with our AI. Perfect for content creators looking to enhance their feed with professional quality photos.',
    description:
      'Create stunning polaroid photos with our AI. Generate professional quality photos that will make your feed stand out and grow your following.',
    skipTitle: true,
    isPhotoPack: false,
    isPhoto: true,
    search_query: 'polaroid photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/6f677980-d14b-4a84-a7de-b98e7f8e1145/24ce387a-d5df-4cee-95f3-8ec408773f24.png',
        prompt:
          'Polaroid photo of a person wearing a creative costume with makeup, decorated house with carved pumpkins and cobwebs, posing with jack-o-lantern, playful spooky expression, orange and purple party lighting',
      },
    ],
  },
  // Tinder Profile Photos
  {
    slug: 'tinder-profile',
    name: 'Tinder',
    header: 'Create Stunning Tinder Profile Photos',
    seo_description:
      'Generate stunning Tinder profile photos with our AI. Perfect for dating apps looking to enhance your profile with professional quality photos.',
    description:
      'Create stunning Tinder profile photos with our AI. Generate professional quality photos that will make your profile stand out and get more matches.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'tinder profile photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/743af6a7-1414-4fd7-82e5-50f85f188e58.png',
        prompt:
          'professional dating profile photo, person with genuine smile, well-lit outdoor setting with natural background, casual stylish outfit, confident approachable expression, soft natural lighting',
      },
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/83718e7c-96a6-47fa-a0c0-39c8d01f5fb4.png',
        prompt:
          'tinder profile photo, person with genuine smile, well-lit outdoor setting with natural background, casual stylish outfit, confident approachable expression, soft natural lighting',
      },
    ],
  },
  // Hinge Profile Photos
  {
    slug: 'hinge-profile',
    name: 'Hinge',
    header: 'Create Stunning Hinge Profile Photos',
    seo_description:
      'Generate stunning Hinge profile photos with our AI. Perfect for dating apps looking to enhance your profile with professional quality photos.',
    description:
      'Create stunning Hinge profile photos with our AI. Generate professional quality photos that will make your profile stand out and get more meaningful connections.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'profile photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/hinge-profile-hero.mp4',
        prompt:
          'professional dating profile photo, person with genuine smile, well-lit outdoor setting with natural background, casual stylish outfit, confident approachable expression, soft natural lighting',
      },
    ],
  },
  // Yoga & Wellness Photos
  {
    slug: 'yoga-wellness',
    name: 'Yoga & Wellness',
    header: 'Create Stunning Yoga & Wellness Photos',
    seo_description:
      'Generate stunning yoga and wellness photos with our AI. Perfect for yoga instructors and wellness coaches looking to enhance their brand with professional quality photos.',
    description:
      'Create stunning yoga and wellness photos with our AI. Generate professional quality photos that will showcase your practice and inspire your community.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'yoga photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/326d511d-0895-4dd5-a441-230cb2723554.png',
        prompt:
          'serene yoga photo, person in tree pose on yoga mat, peaceful studio with plants and natural light, wearing comfortable activewear, calm focused expression, soft morning lighting',
      },
    ],
  },
  // Entrepreneur Photos
  {
    slug: 'entrepreneur',
    name: 'Entrepreneur',
    header: 'Create Stunning Entrepreneur Photos',
    seo_description:
      'Generate stunning entrepreneur photos with our AI. Perfect for business owners and startup founders looking to enhance their personal brand with professional quality photos.',
    description:
      'Create stunning entrepreneur photos with our AI. Generate professional quality photos that will establish your authority and build trust with your audience.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'entrepreneur photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/bc121bbf-9f75-4e58-acbf-184e364e8775.png',
        prompt:
          'professional entrepreneur photo, person in business casual attire, modern office or co-working space, confident stance with arms crossed or thoughtful pose, determined focused expression, natural window lighting',
      },
    ],
  },
  // Bumble Profile Photos
  {
    slug: 'bumble-profile',
    name: 'Bumble',
    header: 'Create Stunning Bumble Profile Photos',
    seo_description:
      'Generate stunning Bumble profile photos with our AI. Perfect for dating apps looking to enhance your profile with professional quality photos.',
    description:
      'Create stunning Bumble profile photos with our AI. Generate professional quality photos that will make your profile stand out and attract meaningful matches.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'dating profile photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/755597a3-fbf0-41d3-b91f-d787dca37017.png',
        prompt:
          'bumble profile photo, person with genuine smile, well-lit outdoor setting with natural background, casual stylish outfit, confident approachable expression, soft natural lighting',
      },
    ],
  },
  // Beach Bikini Photos
  {
    slug: 'beach-bikini',
    name: 'Beach Bikini',
    header: 'Create Stunning Beach Bikini Photos',
    seo_description:
      'Generate stunning beach bikini photos with our AI. Perfect for content creators and influencers looking to enhance their feed with professional quality beach photos.',
    description:
      'Create stunning beach bikini photos with our AI. Generate professional quality photos that will showcase your confidence and style at the beach.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'beach bikini photo',
    images: [
      {
        // Animated hero: still animated with Seedance 2.0 Mini Image
        // (720p, 5s, 1:1) — 5s rather than the usual 4 because the beat has
        // three parts (she notices the camera, smiles, puts on her hat) and
        // 4s rushes the reach for the hat. Ends hat-on, so the loop cuts back
        // to the opening pose.
        url: 'https://media.easy-peasy.ai/landing/image-styles/beach-bikini.mp4',
        prompt:
          'beach bikini photo, person in stylish bikini, beautiful beach with turquoise water and golden sand, relaxed confident pose, sunny beach day, bright natural sunlight',
      },
    ],
  },
  // AI Girlfriend Photos
  {
    slug: 'ai-girlfriend',
    name: 'Girlfriend',
    header: 'Create Your AI Girlfriend Photos',
    seo_description:
      'Generate stunning AI girlfriend photos with our AI. Create your perfect virtual companion with professional quality AI-generated photos.',
    description:
      'Create your AI girlfriend photos with our advanced AI. Generate beautiful, realistic photos of your virtual companion with customizable features and styles.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'ai girlfriend photo',
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/ai-girlfriend-hero.mp4',
        prompt:
          'portrait photo, attractive woman with friendly smile, modern casual setting, warm welcoming expression, soft natural lighting, realistic photographic style',
      },
    ],
  },
  // Chinese New Year Photos
  {
    slug: 'chinese-new-year',
    name: 'Chinese New Year',
    header: 'Create Stunning Chinese New Year Photos',
    seo_description:
      'Generate stunning Chinese New Year photos with our AI. Perfect for celebrating the lunar new year with professional quality festive photos.',
    description:
      'Create stunning Chinese New Year photos with our AI. Generate professional quality photos that capture the joy and traditions of the lunar new year celebration.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'chinese new year photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/18e8f051-5038-4072-9cc7-d47b4c8ece68.png',
        prompt:
          'chinese new year celebration photo, person wearing traditional red outfit or qipao, festive decorations with red lanterns and gold ornaments, holding red envelope or lucky charm, joyful celebratory expression, warm festive lighting',
      },
    ],
  },
  // Hanukkah Photos
  {
    slug: 'hanukkah',
    name: 'Hanukkah',
    header: 'Create Stunning Hanukkah Photos',
    seo_description:
      'Generate stunning Hanukkah photos with our AI. Perfect for celebrating the Festival of Lights with professional quality festive photos.',
    description:
      'Create stunning Hanukkah photos with our AI. Generate professional quality photos that capture the beauty and traditions of the Festival of Lights.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'hanukkah photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/aaff4bbe-82de-4e8d-9e1a-fd0aec590cf9.png',
        prompt:
          'hanukkah celebration photo, person lighting menorah candles, festive decorations with blue and white colors, dreidels and gelt nearby, warm joyful expression, soft candlelight glow',
      },
    ],
  },
  // Hair Color Try On
  {
    slug: 'hair-color-try-on',
    name: 'Hair Color Try On',
    header: 'Try On Hair Colors Virtually',
    seo_description:
      'Try on different hair colors virtually with our AI. Perfect for exploring new looks before committing to a change.',
    description:
      'Experiment with different hair colors using our AI. See how various shades look on you before making the commitment to dye your hair.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'hair color try on',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/09d18535-3320-474a-8fd3-dfa152f1da76.png',
        prompt:
          'Professional portrait photo with vibrant hair color, natural lighting, salon-quality hair styling, realistic hair texture and shine, fashion photography, high-resolution detail showing hair color variation and depth',
      },
    ],
  },
  // Weight Loss Simulator
  {
    slug: 'weight-loss-simulator',
    name: 'Weight Loss Simulator',
    header: 'Visualize Your Weight Loss Goals',
    seo_description:
      'Simulate weight loss transformation with our AI. Visualize your potential appearance at different weight goals for motivation and planning.',
    description:
      'Visualize your weight loss journey with our AI. See how you might look at different weight goals to help motivate and plan your fitness transformation.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'what would i look like if i lost weight',
    images: [
      {
        // Animated hero: the existing before/after still, animated with
        // Seedance 2.0 Mini Image (720p, 4s, 1:1). The prompt pinned the
        // split screen, the BEFORE/AFTER captions and the bodies in place —
        // only breathing, blinks and the curtains move, so the comparison
        // itself never shifts.
        url: 'https://media.easy-peasy.ai/landing/image-styles/weight-loss-simulator.mp4',
        prompt:
          'Before and after weight loss transformation photo, natural lighting, realistic body proportions, healthy appearance, confident posture, fitness transformation, high-resolution portrait showing realistic weight change visualization',
      },
    ],
  },
  // ASCII Art
  {
    slug: 'ascii-art',
    name: 'ASCII Art',
    header: 'Create Text-Based Masterpieces',
    seo_description:
      'Generate ASCII art with our AI. Transform images into text-based art using characters and symbols for a retro digital aesthetic.',
    description:
      'Create unique ASCII art with our AI. Transform your ideas into text-based artwork using characters and symbols, perfect for retro computing aesthetics.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'ascii',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a07e20f3-9b9b-4a55-87c1-3ea6f2066246.png',
        prompt:
          'ASCII art style image, monochrome text characters forming detailed picture, retro computer terminal aesthetic, dot matrix pattern, black background with white/gray characters, detailed shading using various symbols and letters, vintage digital art',
      },
    ],
  },
  // Wallpaper
  {
    slug: 'wallpaper',
    name: 'Wallpaper',
    header: 'Create Custom Wallpapers',
    seo_description:
      'Generate stunning custom wallpapers with our AI. Perfect for phone backgrounds, desktop wallpapers, and digital art displays.',
    description:
      'Create beautiful custom wallpapers with our AI. Generate unique phone and desktop backgrounds that perfectly match your style and aesthetic preferences.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'wallpaper',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/78b85c73-45f0-4c23-b1f1-26e24c23af2c.png',
        prompt:
          'Beautiful abstract wallpaper design, vibrant gradient colors, smooth flowing shapes, high resolution, perfect for phone and desktop backgrounds, artistic digital art',
      },
    ],
  },
  // Emoji
  {
    slug: 'emoji',
    name: 'Emoji',
    header: 'Create Custom Emojis',
    seo_description:
      'Generate unique custom emoji designs with our AI. Perfect for messaging, social media, and digital communication.',
    description:
      'Design your own custom emojis with our AI. Create expressive and unique emoji designs for personal use, branding, or fun digital communication.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'emoji',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/52a1ecfd-527c-442c-84f8-212f8fb2adce.png',
        prompt:
          'Custom emoji design, expressive cartoon face, bright yellow circular shape, bold clean lines, playful expression, high resolution, isolated on white background',
      },
    ],
  },
  // Meme
  {
    slug: 'meme',
    name: 'Meme',
    header: 'Create Custom Meme Images',
    seo_description:
      'Generate funny and shareable meme images with our AI. Perfect for social media, viral content, and internet humor.',
    description:
      'Create hilarious meme-ready images with our AI. Generate viral-worthy visuals perfect for social media sharing and internet culture.',
    skipTitle: true,
    isPhotoPack: false,
    search_query: 'meme',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/fbefae65-7fc7-4166-9032-317e62458a60.png',
        prompt:
          'Funny meme-style image, exaggerated expression, bold comic style, internet humor aesthetic, high contrast, clear subject, meme template ready',
      },
    ],
  },
  // Floor Plan
  {
    slug: 'floor-plan',
    name: 'Floor Plan',
    header: 'Create AI Floor Plans',
    seo_description:
      'Generate professional floor plan designs with our AI. Perfect for architects, real estate agents, and home renovation projects.',
    description:
      'Design detailed floor plans with our AI. Create professional architectural layouts for homes, offices, and commercial spaces with ease.',
    skipTitle: true,
    isPhotoPack: false,
    search_query: 'floor plan',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9c7101d7-1229-4195-b883-b146715c07e6.png',
        prompt:
          'Professional floor plan layout, architectural drawing, clean lines, labeled rooms, measurements, top-down view, minimalist design, black and white with blue accents',
      },
    ],
  },
  // Map
  {
    slug: 'map',
    name: 'Map',
    header: 'Create Custom Map Designs',
    seo_description:
      'Generate creative custom map designs with our AI. Perfect for game designers, world builders, and creative projects.',
    description:
      'Design unique custom maps with our AI. Create detailed maps for games, stories, presentations, and creative projects with stunning visual detail.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'map',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/ca15f263-4699-4a64-93a9-4c2e6d285b81.png',
        prompt:
          'Detailed illustrated map design, cartographic style, labeled locations, decorative compass rose, terrain details with mountains and rivers, vintage parchment aesthetic',
      },
    ],
  },
  // Hairstyle
  {
    slug: 'hairstyle',
    name: 'Hairstyle',
    header: 'Try On Hairstyles Virtually',
    seo_description:
      'Try on different hairstyles virtually with our AI. Perfect for exploring new looks before visiting the salon.',
    description:
      'Experiment with different hairstyles using our AI. See how various cuts, colors, and styles look on you before making a commitment.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'hairstyle try on',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/64b820b5-20b1-4675-9097-84673b116650.png',
        prompt:
          'Professional hairstyle portrait, trendy modern haircut, salon-quality styling, natural lighting, detailed hair texture and volume, fashion photography',
      },
    ],
  },
  // Room Design
  {
    slug: 'room-design',
    name: 'Room Design',
    header: 'Visualize Your Dream Room',
    seo_description:
      'Generate stunning room design visualizations with our AI. Perfect for interior design planning, home renovation, and decorating inspiration.',
    description:
      'Visualize your dream room with our AI. Create photorealistic interior design concepts for any space, from bedrooms to living rooms and beyond.',
    skipTitle: true,
    isPhotoPack: false,
    search_query: 'room design',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/eb549756-1036-4dac-bcca-7cdd440c7c14.png',
        prompt:
          'Beautiful modern room interior design, stylish furniture arrangement, warm natural lighting, cozy atmosphere, professional interior photography, high-end decor',
      },
    ],
  },
  // Manga
  {
    slug: 'manga',
    name: 'Manga',
    header: 'Create Manga-Style Art',
    seo_description:
      'Generate authentic manga-style artwork with our AI. Perfect for comic creators, illustrators, and Japanese art enthusiasts.',
    description:
      'Create stunning manga-style illustrations with our AI. Generate authentic Japanese comic art with dynamic poses, expressive characters, and detailed linework.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'manga',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/manga-hero.mp4',
        prompt:
          'Manga-style illustration, Japanese comic art, detailed linework, expressive character with large eyes, dynamic pose, black and white with screentone shading, professional manga quality',
      },
    ],
  },
  // Blueprint
  {
    slug: 'blueprint',
    name: 'Blueprint',
    header: 'Create Blueprint Designs',
    seo_description:
      'Generate professional blueprint designs with our AI. Perfect for architecture, engineering, and technical drawing projects.',
    description:
      'Create detailed blueprint designs with our AI. Generate professional technical drawings for architecture, engineering, and construction projects.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'blueprint',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/773c1de9-cbdf-4d59-a4c2-1c5768cc7e21.png',
        prompt:
          'Technical blueprint design, white lines on deep blue background, architectural drawing with measurements and annotations, engineering schematic style, precise technical illustration',
      },
    ],
  },
  // Wireframe
  {
    slug: 'wireframe',
    name: 'Wireframe',
    header: 'Create Wireframe Designs',
    seo_description:
      'Generate clean wireframe designs with our AI. Perfect for UI/UX designers, developers, and product teams.',
    description:
      'Design clean wireframes with our AI. Create professional UI/UX wireframe layouts for websites, apps, and digital products quickly and easily.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'wireframe',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f3abc8cb-8e26-4d41-bb34-4e94086bca7b.png',
        prompt:
          'Clean wireframe UI design, gray boxes and lines on white background, website layout mockup, placeholder text and images, minimal design system, professional UX wireframe',
      },
    ],
  },
  // Makeup
  {
    slug: 'makeup',
    name: 'Makeup',
    header: 'Try On Makeup Looks Virtually',
    seo_description:
      'Try on different makeup looks virtually with our AI. Perfect for beauty enthusiasts exploring new styles before buying products.',
    description:
      'Experiment with different makeup styles using our AI. See how various looks, from natural to glamorous, would appear on you before committing.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'makeup look',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c8a622d4-90da-4425-a4d1-ab900cb1fb10.png',
        prompt:
          'Professional makeup portrait, flawless beauty look, expertly applied cosmetics, soft studio lighting, detailed skin texture, fashion beauty photography, high-end makeup artistry',
      },
    ],
  },
  // Passport Photo
  {
    slug: 'passport-photo',
    name: 'Passport Photo',
    header: 'Create Passport Photos',
    seo_description:
      'Generate compliant passport photo images with our AI. Perfect for visa applications, ID documents, and official photo requirements.',
    description:
      'Create professional passport-style photos with our AI. Generate clean, well-lit headshots suitable for official documents and identification purposes.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'passport photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/edfd45ba-4c3e-4eae-8aa0-39e3d45a97f9.png',
        prompt:
          'Professional passport photo, white background, neutral expression, even studio lighting, head and shoulders framing, formal appearance, high resolution, ID photo compliant',
      },
    ],
  },
  // ID Photo
  {
    slug: 'id-photo',
    name: 'ID Photo',
    header: 'Create ID Photos',
    seo_description:
      'Generate professional ID photo images with our AI. Perfect for identification cards, badges, and official documentation.',
    description:
      'Create clean ID photos with our AI. Generate professional headshots suitable for employee badges, student IDs, and various identification needs.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'id photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b5b0cf17-f3ca-48a3-a971-3c9ac7334b57.png',
        prompt:
          'Professional ID photo, clean solid background, neutral expression, even lighting, head and shoulders framing, formal attire, sharp focus, identification photo standard',
      },
    ],
  },
  // Couple Photo
  {
    slug: 'couple-photo',
    name: 'Couple Photo',
    header: 'Create Beautiful Couple Photos',
    seo_description:
      'Generate beautiful couple photos with our AI. Perfect for romantic portraits, anniversary celebrations, and relationship milestones.',
    description:
      'Create stunning couple photos with our AI. Generate romantic portraits and creative couple images that celebrate love and togetherness.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'couple photo',
    images: [
      {
        // Animated hero: supplied clip at its native 16:9, muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/couple-photo-hero.mp4',
        prompt:
          'Romantic couple portrait, warm natural lighting, genuine loving expressions, beautiful outdoor setting, professional photography quality, soft bokeh background',
      },
    ],
  },
  // Certificate
  {
    slug: 'certificate',
    name: 'Certificate',
    header: 'Create Certificate Designs',
    seo_description:
      'Generate professional certificate designs with our AI. Perfect for awards, diplomas, achievements, and recognition documents.',
    description:
      'Design professional certificates with our AI. Create elegant award certificates, diplomas, and recognition documents for any occasion.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'certificate design',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/444ae3ef-d49c-4ee6-ba95-edb54bdf2eba.png',
        prompt:
          'Elegant certificate design, ornate gold border, professional typography, formal layout with seal and ribbon, premium paper texture, award document style',
      },
    ],
  },
  // Chibi
  {
    slug: 'chibi',
    name: 'Chibi',
    header: 'Create Adorable Chibi Characters',
    seo_description:
      'Generate cute chibi character designs with our AI. Perfect for creating adorable miniature anime-style characters with oversized heads.',
    description:
      'Create adorable chibi-style characters with our AI. Design cute miniature characters with oversized heads, big eyes, and tiny bodies in the beloved Japanese art style.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'chibi character',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/df9d7734-c633-4e7c-85ed-ce5fef7d2dbc.png',
        prompt:
          'Cute chibi character design, oversized head with big sparkly eyes, tiny body, adorable proportions, bright colors, kawaii anime style, clean linework',
      },
    ],
  },
  // Calligraphy
  {
    slug: 'calligraphy',
    name: 'Calligraphy',
    header: 'Create Beautiful Calligraphy Art',
    seo_description:
      'Generate stunning calligraphy and lettering art with our AI. Perfect for wedding invitations, quotes, logos, and decorative text designs.',
    description:
      'Create beautiful calligraphy designs with our AI. Generate elegant hand-lettered text art for invitations, quotes, branding, and decorative purposes.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'calligraphy',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9c6c984a-da00-4bdf-abbb-e8983476feea.png',
        prompt:
          'Beautiful calligraphy lettering, elegant flowing script, black ink on white paper, ornate flourishes and swashes, professional hand-lettering style, decorative typography art',
      },
    ],
  },
  // Abstract Art
  {
    slug: 'abstract-art',
    name: 'Abstract Art',
    header: 'Create Abstract Art',
    seo_description:
      'Generate stunning abstract artwork with our AI. Perfect for modern wall art, digital prints, and creative expression.',
    description:
      'Create captivating abstract art with our AI. Generate bold, colorful, and thought-provoking abstract compositions for wall art, prints, and digital displays.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'abstract art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/088293ba-11f1-4615-97f6-320fcf3e977f.png',
        prompt:
          'Bold abstract art composition, vibrant colors, dynamic shapes and forms, expressive brushstrokes, modern contemporary style, museum-quality abstract painting',
      },
    ],
  },
  // Profile Picture
  {
    slug: 'profile-picture',
    name: 'Profile Picture',
    header: 'Create Perfect Profile Pictures',
    seo_description:
      'Generate eye-catching profile pictures with our AI. Perfect for social media accounts, gaming avatars, and online presence.',
    description:
      'Create the perfect profile picture with our AI. Generate stunning social media profile photos and avatars that make a great first impression.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'profile picture',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/6ad73a06-a075-4dfd-a205-33f341ce9b95.png',
        prompt:
          'Perfect social media profile picture, flattering lighting, confident expression, clean background, high resolution, professional yet approachable, square crop',
      },
    ],
  },
  // Photo Booth
  {
    slug: 'photo-booth',
    name: 'Photo Booth',
    header: 'Create Fun Photo Booth Images',
    seo_description:
      'Generate fun photo booth style images with our AI. Perfect for parties, events, and creating memorable group photos with creative props.',
    description:
      'Create exciting photo booth images with our AI. Generate party-ready photos with fun props, creative backdrops, and festive themes.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'photo booth',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1dab91f2-d7d6-4349-abba-66316c95728a.png',
        prompt:
          'Fun photo booth style image, colorful backdrop, party props like hats and glasses, multiple fun poses, strip format, playful lighting, celebration atmosphere',
      },
    ],
  },
  // Garden Design
  {
    slug: 'garden-design',
    name: 'Garden Design',
    header: 'Visualize Your Dream Garden',
    seo_description:
      'Generate beautiful garden design visualizations with our AI. Perfect for landscape planning, backyard makeovers, and outdoor space inspiration.',
    description:
      'Visualize your dream garden with our AI. Create stunning landscape designs and garden layouts for any outdoor space.',
    skipTitle: true,
    isPhotoPack: false,
    search_query: 'garden design',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/87561d42-a691-4cb9-bdcf-256d836aa8ef.png',
        prompt:
          'Beautiful garden landscape design, lush green plants and colorful flowers, stone pathway, water feature, professional landscape photography, well-maintained garden',
      },
    ],
  },
  // Shoe Design
  {
    slug: 'shoe-design',
    name: 'Shoe Design',
    header: 'Create Custom Shoe Designs',
    seo_description:
      'Generate creative shoe and sneaker designs with our AI. Perfect for footwear designers, sneakerheads, and fashion enthusiasts.',
    description:
      'Design custom shoes and sneakers with our AI. Create unique footwear concepts from athletic sneakers to luxury designs.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'shoe design',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1ce7052b-8bd1-4462-8b57-a338e8ebafe8.png',
        prompt:
          'Custom sneaker design concept, creative colorful shoe, detailed sole and upper design, product photography style, clean background, fashion footwear illustration',
      },
    ],
  },
  // Trophy
  {
    slug: 'trophy',
    name: 'Trophy',
    header: 'Create Trophy and Award Designs',
    seo_description:
      'Generate creative trophy and award designs with our AI. Perfect for competitions, recognition events, and achievement visuals.',
    description:
      'Design unique trophies and awards with our AI. Create stunning award visuals for competitions, corporate recognition, and achievement celebrations.',
    skipTitle: true,
    isPhotoPack: false,
    search_query: 'trophy design',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/trophy-hero.mp4',
        prompt:
          'Elegant trophy design, golden award cup on marble base, dramatic lighting, reflective metallic surface, achievement and victory symbol, product photography style',
      },
    ],
  },
  // Mandala
  {
    slug: 'mandala',
    name: 'Mandala',
    header: 'Create Beautiful Mandala Art',
    seo_description:
      'Generate intricate mandala designs with our AI. Perfect for meditation, coloring pages, wall art, and spiritual artwork.',
    description:
      'Create stunning mandala art with our AI. Generate intricate circular patterns perfect for meditation, coloring, printing, and decorative purposes.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'mandala art',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 5s, 1:1) as a slow continuous rotation of the pattern about its centre,
        // muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/mandala-hero.mp4',
        prompt:
          'Intricate mandala design, symmetrical circular pattern, detailed geometric and floral elements, black ink on white background, meditative art, precise linework',
      },
    ],
  },
  // Easter Photo
  {
    slug: 'easter-photo',
    name: 'Easter Photo',
    header: 'Create Stunning Easter Photos',
    seo_description:
      'Generate beautiful Easter photos with our AI. Perfect for spring celebrations, egg hunts, and festive family portraits.',
    description:
      'Create stunning Easter photos with our AI. Generate professional quality festive photos with spring themes, Easter eggs, and bunny motifs.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'easter',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1f19f557-c6a4-4bac-893a-b6aab6225d8a.png',
        prompt:
          'Beautiful Easter portrait, spring flowers and pastel colors, decorated Easter eggs, bunny ears, soft warm lighting, festive spring atmosphere',
      },
    ],
  },
  {
    slug: 'thanksgiving-photo',
    name: 'Thanksgiving Photo',
    header: 'Create Stunning Thanksgiving Photos',
    seo_description:
      'Generate beautiful Thanksgiving photos with our AI. Perfect for family gatherings, harvest celebrations, and autumn-themed portraits.',
    description:
      'Create stunning Thanksgiving photos with our AI. Generate professional quality photos with autumn themes, harvest decor, and family gathering scenes.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'thanksgiving photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/41864b84-c7f3-4d69-b469-76986000f238.png',
        prompt:
          'Warm Thanksgiving family photo, autumn colors, harvest decorations, pumpkins and fall leaves, cozy dining scene, warm golden lighting',
      },
    ],
  },
  // Eid Photo
  {
    slug: 'eid-photo',
    name: 'Eid Photo',
    header: 'Create Beautiful Eid Photos',
    seo_description:
      'Generate beautiful Eid celebration photos with our AI. Perfect for Eid al-Fitr and Eid al-Adha portraits and family photos.',
    description:
      'Create stunning Eid photos with our AI. Generate professional quality festive photos that capture the joy and beauty of Eid celebrations.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'eid photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e932452d-eb49-4a5b-b2d7-65b709f296cf.png',
        prompt:
          'Beautiful Eid celebration portrait, elegant traditional attire, festive decorations with lanterns and crescent moon, warm lighting, joyful celebration atmosphere',
      },
    ],
  },
  // Diwali Photo
  {
    slug: 'diwali-photo',
    name: 'Diwali Photo',
    header: 'Create Stunning Diwali Photos',
    seo_description:
      'Generate beautiful Diwali celebration photos with our AI. Perfect for the Festival of Lights portraits and family photos.',
    description:
      'Create stunning Diwali photos with our AI. Generate professional quality festive photos that capture the radiance and joy of the Festival of Lights.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'diwali photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2dafaff5-ecba-4f2c-b5ab-81d47809c85a.png',
        prompt:
          'Beautiful Diwali celebration portrait, traditional Indian attire, diyas and string lights, rangoli decorations, warm golden glow, festive atmosphere',
      },
    ],
  },
  // Ramadan Photo
  {
    slug: 'ramadan-photo',
    name: 'Ramadan Photo',
    header: 'Create Beautiful Ramadan Photos',
    seo_description:
      'Generate beautiful Ramadan photos with our AI. Perfect for celebrating the holy month with professional quality portraits.',
    description:
      'Create stunning Ramadan photos with our AI. Generate professional quality photos that capture the spirituality and beauty of the holy month.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'ramadan photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/50b9f4b3-5ff2-4284-875e-ac8f258e85f5.png',
        prompt:
          'Beautiful Ramadan portrait, crescent moon and lanterns, traditional attire, soft warm lighting, mosque silhouette in background, peaceful spiritual atmosphere',
      },
    ],
  },
  // 4th of July Photo
  {
    slug: '4th-of-july-photo',
    name: '4th of July Photo',
    header: 'Create Patriotic 4th of July Photos',
    seo_description:
      'Generate patriotic 4th of July photos with our AI. Perfect for Independence Day celebrations and American-themed portraits.',
    description:
      'Create stunning 4th of July photos with our AI. Generate patriotic images with fireworks, American flags, and red, white, and blue themes.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: '4th of july photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f04480a5-3040-4ef5-a59a-806fe5b1e5ed.png',
        prompt:
          'Patriotic 4th of July portrait, red white and blue colors, American flag backdrop, fireworks in background, festive celebration atmosphere, summer outdoor setting',
      },
    ],
  },
  // Birthday Photo
  {
    slug: 'birthday-photo',
    name: 'Birthday Photo',
    header: 'Create Amazing Birthday Photos',
    seo_description:
      'Generate fun birthday photos with our AI. Perfect for birthday celebrations, party invitations, and milestone birthday portraits.',
    description:
      'Create amazing birthday photos with our AI. Generate festive birthday portraits with balloons, cakes, and celebration themes for any age.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'birthday photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/birthday-photo-hero.mp4',
        prompt:
          'Fun birthday celebration portrait, colorful balloons and confetti, birthday cake with candles, festive party decorations, joyful expression, warm party lighting',
      },
    ],
  },
  // Birthday Card
  {
    slug: 'birthday-card',
    name: 'Birthday Card',
    header: 'Create Your Own Birthday Card',
    seo_description:
      'Generate beautiful birthday card designs with our AI. Perfect for creating personalized greeting cards for any birthday celebration.',
    description:
      'Design beautiful birthday cards with our AI. Create personalized birthday greeting cards with fun themes, colors, and celebratory designs.',
    skipTitle: false,
    isPhotoPack: false,
    search_query: 'birthday card',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9b94b5a7-c43b-4dbe-bc27-fc21aeda8557.png',
        prompt:
          'Colorful birthday card design, balloons and confetti, fun typography, cake illustration, celebratory colors, space for personalized birthday message',
      },
    ],
  },
  // Baby Shower Photo
  {
    slug: 'baby-shower-photo',
    name: 'Baby Shower Photo',
    header: 'Create Beautiful Baby Shower Photos',
    seo_description:
      'Generate adorable baby shower photos with our AI. Perfect for baby shower invitations, decorations, and celebration memories.',
    description:
      'Create beautiful baby shower photos with our AI. Generate sweet and adorable images perfect for baby shower celebrations and announcements.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'baby shower photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/baby-shower-photo-hero.mp4',
        prompt:
          'Beautiful baby shower portrait, soft pastel colors, baby-themed decorations, balloons and flowers, gentle warm lighting, sweet celebration atmosphere',
      },
    ],
  },

  // Back to School Photo
  {
    slug: 'back-to-school-photo',
    name: 'Back to School Photo',
    header: 'Create Fun Back to School Photos',
    seo_description:
      'Generate exciting back to school photos with our AI. Perfect for first day of school portraits and academic milestone photos.',
    description:
      'Create fun back to school photos with our AI. Generate memorable first-day portraits with school themes, supplies, and academic settings.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'back to school photo',
    images: [
      {
        // Animated hero: reuses the school-photo clip — the two styles show
        // the same thing, so they share one file rather than a second upload.
        url: 'https://media.easy-peasy.ai/landing/image-styles/school-photo-hero.mp4',
        prompt:
          'Fun back to school portrait, wearing backpack, school supplies, chalkboard background, bright and cheerful colors, excited first day of school expression',
      },
    ],
  },
  // Engagement Photo
  {
    slug: 'engagement-photo',
    name: 'Engagement Photo',
    header: 'Create Stunning Engagement Photos',
    seo_description:
      'Generate beautiful engagement photos with our AI. Perfect for save-the-dates, announcements, and celebrating your love story.',
    description:
      'Create stunning engagement photos with our AI. Generate romantic couple portraits perfect for save-the-dates and celebration announcements.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'engagement photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted.
        url: 'https://media.easy-peasy.ai/landing/image-styles/engagement-photo-hero.mp4',
        prompt:
          'Romantic engagement portrait, couple with engagement ring, golden hour lighting, beautiful outdoor setting, loving expressions, professional photography quality',
      },
    ],
  },
  // Newborn Photo
  {
    slug: 'newborn-photo',
    name: 'Newborn Photo',
    header: 'Create Precious Newborn Photos',
    seo_description:
      'Generate precious newborn photos with our AI. Perfect for birth announcements, nursery decor, and capturing those precious first moments.',
    description:
      'Create precious newborn photos with our AI. Generate beautiful baby portraits in classic newborn photography styles with soft, gentle aesthetics.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'newborn photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3df92a41-94a1-49b4-9b21-41e78afb7157.png',
        prompt:
          'Precious newborn baby portrait, soft blanket wrap, gentle studio lighting, warm neutral tones, peaceful sleeping pose, professional newborn photography',
      },
    ],
  },
  // Prom Photo
  {
    slug: 'prom-photo',
    name: 'Prom Photo',
    header: 'Create Stunning Prom Photos',
    seo_description:
      'Generate glamorous prom photos with our AI. Perfect for prom night portraits, group photos, and memorable high school moments.',
    description:
      'Create stunning prom photos with our AI. Generate glamorous prom night portraits with elegant attire, beautiful settings, and memorable poses.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'prom photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f79bf2b8-32f9-450d-9fb7-9178b5953530.png',
        prompt:
          'Glamorous prom portrait, formal evening attire, elegant backdrop with fairy lights, confident pose, professional event photography, sparkle and glamour',
      },
    ],
  },
  // Aesthetic Photo
  {
    slug: 'aesthetic-photo',
    name: 'Aesthetic Photo',
    header: 'Create Aesthetic Photos',
    seo_description:
      'Generate trendy aesthetic photos with our AI. Perfect for social media feeds, mood boards, and creating cohesive visual content.',
    description:
      'Create stunning aesthetic photos with our AI. Generate visually cohesive, trendy images perfect for curated social media feeds and digital mood boards.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'aesthetic photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b551ac31-c312-48d1-93f7-c7de4f43d0d7.png',
        prompt:
          'Aesthetic photo, soft muted tones, carefully curated composition, trendy minimalist style, warm golden light, Instagram-worthy visual, dreamy atmosphere',
      },
    ],
  },
  // Retro Photo
  {
    slug: 'retro-photo',
    name: 'Retro Photo',
    header: 'Create Retro-Style Photos',
    seo_description:
      'Generate nostalgic retro-style photos with our AI. Perfect for 70s, 80s, and 90s inspired visuals with vintage filter effects.',
    description:
      'Create nostalgic retro photos with our AI. Generate images with authentic vintage filter effects inspired by the 70s, 80s, and 90s eras.',
    skipTitle: true,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'retro photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f79bf2b8-32f9-450d-9fb7-9178b5953530.png',
        prompt:
          'Retro-style photo, vintage film grain, faded warm colors, 70s nostalgic aesthetic, light leaks and soft focus, analog photography feel, throwback vibes',
      },
    ],
  },
  // Surreal Art
  {
    slug: 'surreal-art',
    name: 'Surreal Art',
    header: 'Create Surreal Artwork',
    seo_description:
      'Generate mind-bending surreal artwork with our AI. Perfect for dreamlike compositions, fantasy scenes, and imaginative visual art.',
    description:
      'Create captivating surreal art with our AI. Generate dreamlike, imaginative compositions that bend reality and spark the imagination.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'surreal art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3eb99ee1-540a-41ee-86cb-4dcb94512920.png',
        prompt:
          'Surreal dreamlike artwork, impossible architecture, floating objects, melting clocks, vivid imagination, fantasy landscape, mind-bending perspective, ethereal atmosphere',
      },
    ],
  },
  // Psychedelic Art
  {
    slug: 'psychedelic-art',
    name: 'Psychedelic Art',
    header: 'Create Psychedelic Artwork',
    seo_description:
      'Generate vibrant psychedelic artwork with our AI. Perfect for trippy visuals, concert posters, and colorful mind-expanding art.',
    description:
      'Create vibrant psychedelic art with our AI. Generate colorful, trippy visuals with swirling patterns, bold colors, and mind-expanding designs.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'psychedelic art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/34f71a08-ded0-4af3-825d-fcd8ffdf3239.png',
        prompt:
          'Vibrant psychedelic artwork, swirling rainbow colors, kaleidoscopic patterns, trippy optical illusions, neon hues, mind-bending fractals, 1960s inspired art',
      },
    ],
  },
  // Minimalist Art
  {
    slug: 'minimalist-art',
    name: 'Minimalist Art',
    header: 'Create Minimalist Artwork',
    seo_description:
      'Generate clean minimalist artwork with our AI. Perfect for modern wall art, simple designs, and less-is-more aesthetics.',
    description:
      'Create elegant minimalist art with our AI. Generate clean, simple compositions that embrace the less-is-more philosophy for modern wall art and designs.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'minimalist art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e83a5a7a-886f-4c16-b925-94b5c2787e66.png',
        prompt:
          'Clean minimalist artwork, simple geometric shapes, limited color palette, lots of white space, elegant composition, modern contemporary art, refined simplicity',
      },
    ],
  },
  // Geometric Art
  {
    slug: 'geometric-art',
    name: 'Geometric Art',
    header: 'Create Geometric Artwork',
    seo_description:
      'Generate stunning geometric artwork with our AI. Perfect for modern wall art, patterns, and mathematically-inspired designs.',
    description:
      'Create striking geometric art with our AI. Generate precise, mathematically-inspired designs with bold shapes, patterns, and symmetry.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'geometric art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/92526eb4-0e71-43bf-a386-bc1084812029.png',
        prompt:
          'Bold geometric artwork, precise shapes and angles, symmetrical patterns, vibrant color blocks, mathematical precision, modern art style, clean edges',
      },
    ],
  },
  // Kawaii
  {
    slug: 'kawaii',
    name: 'Kawaii',
    header: 'Create Cute Kawaii Art',
    seo_description:
      'Generate adorable kawaii-style artwork with our AI. Perfect for cute Japanese-inspired characters, stickers, and playful designs.',
    description:
      'Create adorable kawaii art with our AI. Generate super cute Japanese-inspired designs with happy faces, pastel colors, and irresistible charm.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'kawaii art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8eb22d85-e9bb-48af-9f53-25014d12c2b8.png',
        prompt:
          'Adorable kawaii style art, super cute character with big sparkly eyes, pastel pink and blue colors, happy smiling face, rounded soft shapes, Japanese cute aesthetic',
      },
    ],
  },
  // Pastel Art
  {
    slug: 'pastel-art',
    name: 'Pastel Art',
    header: 'Create Soft Pastel Artwork',
    seo_description:
      'Generate beautiful pastel-toned artwork with our AI. Perfect for gentle, soft-colored art prints, nursery decor, and calming visuals.',
    description:
      'Create beautiful pastel art with our AI. Generate gentle, soft-colored artwork with muted tones perfect for prints, decor, and calming visual experiences.',
    skipTitle: true,
    isArt: true,
    isPhotoPack: false,
    search_query: 'pastel art',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/524329e8-6336-4b33-80d3-89b792209452.png',
        prompt:
          'Soft pastel artwork, gentle muted colors, dreamy lavender pink and mint tones, delicate brushwork, calming serene composition, cotton candy color palette',
      },
    ],
  },
  // Sports Photo
  {
    slug: 'sports-photo',
    name: 'Sports Photo',
    header: 'Create Dynamic Sports Photos',
    seo_description:
      'Generate exciting sports action photos with our AI. Perfect for athletic portraits, team photos, and sports marketing materials.',
    description:
      'Create dynamic sports photos with our AI. Generate action-packed athletic images perfect for team photos, sports marketing, and athlete portraits.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'sports photo',
    images: [
      {
        url: 'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/71e7b089-ff02-4e8d-b755-6be5770b717b.png',
        prompt:
          'Dynamic sports action photo, athlete in motion, dramatic lighting, intense focus, stadium background, professional sports photography, high-speed capture feel',
      },
    ],
  },
  // Military Photo
  {
    slug: 'military-photo',
    name: 'Military Photo',
    header: 'Create Military-Style Photos',
    seo_description:
      'Generate professional military-style photos with our AI. Perfect for service member portraits, veteran tributes, and patriotic imagery.',
    description:
      'Create professional military photos with our AI. Generate dignified service member portraits and military-themed imagery with respect and honor.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'military photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/military-photo-hero.mp4',
        prompt:
          'Professional military portrait, dignified uniform, formal pose, American flag backdrop, patriotic atmosphere, respectful and honorable, sharp focus, official portrait style',
      },
    ],
  },
  // School Photo
  {
    slug: 'school-photo',
    name: 'School Photo',
    header: 'Create School Portrait Photos',
    seo_description:
      'Generate classic school portrait photos with our AI. Perfect for class photos, school ID pictures, and academic portraits.',
    description:
      'Create classic school photos with our AI. Generate traditional school portraits and class photos with the familiar school photo backdrop and style.',
    skipTitle: false,
    isPhoto: true,
    isPhotoPack: false,
    search_query: 'school photo',
    images: [
      {
        // Animated hero: still from GPT Image 2 Medium, animated with Seedance
        // 2.0 Mini Image (720p, 4s, 1:1), muted and re-encoded to 720x720.
        url: 'https://media.easy-peasy.ai/landing/image-styles/school-photo-hero.mp4',
        prompt:
          'Classic school portrait photo, gradient blue backdrop, neat appearance, friendly smile, shoulders and head framing, studio lighting, traditional school photo style',
      },
    ],
  },
];

export type ImageStyleType = (typeof image_styles)[0];
